import { x as de, i as E, t as Z, T as lt, m as Zi, n as Qi, o as ki, v as P, u as ve, l as ts, b as V, f as ut, g as N, h as St, d as z, s as et, j as ft, a as Ot, e as we, r as es, c as Me, aG as K, a3 as gt, ac as is, ad as ss, k as L, ae as ke, af as Se, Q as T, F as C, ag as De, a7 as Ut, ah as Si, Y as Yt, $ as Xt, C as _e, ai as Vt, aj as os, q as as, w as ns, S as Q, aM as rs, aw as Ht, av as ue, an as hs, ao as ls, ap as Di, E as W, a0 as F, a2 as $, P as Wt, Z as Dt, a1 as be, aF as cs, ay as ct, aA as dt, aB as Pi, aD as Ai, aC as ds, ak as nt, a5 as us, a6 as Pe, a8 as Ae, M as Ci, z as at, O as Y, R as gs, U as fs, V as Ce, W as ps, X as ot, aH as xs, aq as ms, ar as _s, as as bs, aE as ys, a9 as vs, aa as ws, G as Ms, I as Ii, _ as ks, aI as Ie, aJ as Ss, aK as Zt, ax as Ds, a4 as Ps, ab as Qt, J as Te, L as Ti, N as As, aL as Oe, at as Cs, au as Is, K as Ts, A as Os, B as Ls, D as Es, p as ge, az as zs, al as Le, H as Nt } from "./index.es136.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class Rs {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, i, s) {
    const a = e.listeners[s], n = e.duration;
    a.forEach((r) => r({
      chart: t,
      initial: e.initial,
      numSteps: n,
      currentStep: Math.min(i - e.start, n)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = es.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((i, s) => {
      if (!i.running || !i.items.length)
        return;
      const a = i.items;
      let n = a.length - 1, r = !1, h;
      for (; n >= 0; --n)
        h = a[n], h._active ? (h._total > i.duration && (i.duration = h._total), h.tick(t), r = !0) : (a[n] = a[a.length - 1], a.pop());
      r && (s.draw(), this._notify(s, i, t, "progress")), a.length || (i.running = !1, this._notify(s, i, t, "complete"), i.initial = !1), e += a.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let i = e.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, i)), i;
  }
  listen(t, e, i) {
    this._getAnims(t).listeners[e].push(i);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((i, s) => Math.max(i, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const i = e.items;
    let s = i.length - 1;
    for (; s >= 0; --s)
      i[s].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var G = /* @__PURE__ */ new Rs();
const Ee = "transparent", $s = {
  boolean(o, t, e) {
    return e > 0.5 ? t : o;
  },
  color(o, t, e) {
    const i = Me(o || Ee), s = i.valid && Me(t || Ee);
    return s && s.valid ? s.mix(i, e).hexString() : t;
  },
  number(o, t, e) {
    return o + (t - o) * e;
  }
};
class Fs {
  constructor(t, e, i, s) {
    const a = e[i];
    s = Ot([
      t.to,
      s,
      a,
      t.from
    ]);
    const n = Ot([
      t.from,
      a,
      s
    ]);
    this._active = !0, this._fn = t.fn || $s[t.type || typeof n], this._easing = we[t.easing] || we.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = i, this._from = n, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, i) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], a = i - this._start, n = this._duration - a;
      this._start = i, this._duration = Math.floor(Math.max(n, t.duration)), this._total += a, this._loop = !!t.loop, this._to = Ot([
        t.to,
        e,
        s,
        t.from
      ]), this._from = Ot([
        t.from,
        s,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, i = this._duration, s = this._prop, a = this._from, n = this._loop, r = this._to;
    let h;
    if (this._active = a !== r && (n || e < i), !this._active) {
      this._target[s] = r, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[s] = a;
      return;
    }
    h = e / i % 2, h = n && h > 1 ? 2 - h : h, h = this._easing(Math.min(1, Math.max(0, h))), this._target[s] = this._fn(a, r, h);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, i) => {
      t.push({
        res: e,
        rej: i
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", i = this._promises || [];
    for (let s = 0; s < i.length; s++)
      i[s][e]();
  }
}
class Oi {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!E(t))
      return;
    const e = Object.keys(z.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((s) => {
      const a = t[s];
      if (!E(a))
        return;
      const n = {};
      for (const r of e)
        n[r] = a[r];
      (V(a.properties) && a.properties || [
        s
      ]).forEach((r) => {
        (r === s || !i.has(r)) && i.set(r, n);
      });
    });
  }
  _animateOptions(t, e) {
    const i = e.options, s = Vs(t, i);
    if (!s)
      return [];
    const a = this._createAnimations(s, i);
    return i.$shared && Bs(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), a;
  }
  _createAnimations(t, e) {
    const i = this._properties, s = [], a = t.$animations || (t.$animations = {}), n = Object.keys(e), r = Date.now();
    let h;
    for (h = n.length - 1; h >= 0; --h) {
      const l = n[h];
      if (l.charAt(0) === "$")
        continue;
      if (l === "options") {
        s.push(...this._animateOptions(t, e));
        continue;
      }
      const c = e[l];
      let d = a[l];
      const u = i.get(l);
      if (d)
        if (u && d.active()) {
          d.update(u, c, r);
          continue;
        } else
          d.cancel();
      if (!u || !u.duration) {
        t[l] = c;
        continue;
      }
      a[l] = d = new Fs(u, t, l, c), s.push(d);
    }
    return s;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const i = this._createAnimations(t, e);
    if (i.length)
      return G.add(this._chart, i), !0;
  }
}
function Bs(o, t) {
  const e = [], i = Object.keys(t);
  for (let s = 0; s < i.length; s++) {
    const a = o[i[s]];
    a && a.active() && e.push(a.wait());
  }
  return Promise.all(e);
}
function Vs(o, t) {
  if (!t)
    return;
  let e = o.options;
  if (!e) {
    o.options = t;
    return;
  }
  return e.$shared && (o.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function ze(o, t) {
  const e = o && o.options || {}, i = e.reverse, s = e.min === void 0 ? t : 0, a = e.max === void 0 ? t : 0;
  return {
    start: i ? a : s,
    end: i ? s : a
  };
}
function Hs(o, t, e) {
  if (e === !1)
    return !1;
  const i = ze(o, e), s = ze(t, e);
  return {
    top: s.end,
    right: i.end,
    bottom: s.start,
    left: i.start
  };
}
function Ws(o) {
  let t, e, i, s;
  return E(o) ? (t = o.top, e = o.right, i = o.bottom, s = o.left) : t = e = i = s = o, {
    top: t,
    right: e,
    bottom: i,
    left: s,
    disabled: o === !1
  };
}
function Li(o, t) {
  const e = [], i = o._getSortedDatasetMetas(t);
  let s, a;
  for (s = 0, a = i.length; s < a; ++s)
    e.push(i[s].index);
  return e;
}
function Re(o, t, e, i = {}) {
  const s = o.keys, a = i.mode === "single";
  let n, r, h, l;
  if (t === null)
    return;
  let c = !1;
  for (n = 0, r = s.length; n < r; ++n) {
    if (h = +s[n], h === e) {
      if (c = !0, i.all)
        continue;
      break;
    }
    l = o.values[h], N(l) && (a || t === 0 || et(t) === et(l)) && (t += l);
  }
  return !c && !i.all ? 0 : t;
}
function Ns(o, t) {
  const { iScale: e, vScale: i } = t, s = e.axis === "x" ? "x" : "y", a = i.axis === "x" ? "x" : "y", n = Object.keys(o), r = new Array(n.length);
  let h, l, c;
  for (h = 0, l = n.length; h < l; ++h)
    c = n[h], r[h] = {
      [s]: c,
      [a]: o[c]
    };
  return r;
}
function te(o, t) {
  const e = o && o.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function js(o, t, e) {
  return `${o.id}.${t.id}.${e.stack || e.type}`;
}
function Us(o) {
  const { min: t, max: e, minDefined: i, maxDefined: s } = o.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: s ? e : Number.POSITIVE_INFINITY
  };
}
function Ys(o, t, e) {
  const i = o[t] || (o[t] = {});
  return i[e] || (i[e] = {});
}
function $e(o, t, e, i) {
  for (const s of t.getMatchingVisibleMetas(i).reverse()) {
    const a = o[s.index];
    if (e && a > 0 || !e && a < 0)
      return s.index;
  }
  return null;
}
function Fe(o, t) {
  const { chart: e, _cachedMeta: i } = o, s = e._stacks || (e._stacks = {}), { iScale: a, vScale: n, index: r } = i, h = a.axis, l = n.axis, c = js(a, n, i), d = t.length;
  let u;
  for (let g = 0; g < d; ++g) {
    const f = t[g], { [h]: p, [l]: m } = f, x = f._stacks || (f._stacks = {});
    u = x[l] = Ys(s, c, p), u[r] = m, u._top = $e(u, n, !0, i.type), u._bottom = $e(u, n, !1, i.type);
    const v = u._visualValues || (u._visualValues = {});
    v[r] = m;
  }
}
function ee(o, t) {
  const e = o.scales;
  return Object.keys(e).filter((i) => e[i].axis === t).shift();
}
function Xs(o, t) {
  return ft(o, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function qs(o, t, e) {
  return ft(o, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function _t(o, t) {
  const e = o.controller.index, i = o.vScale && o.vScale.axis;
  if (i) {
    t = t || o._parsed;
    for (const s of t) {
      const a = s._stacks;
      if (!a || a[i] === void 0 || a[i][e] === void 0)
        return;
      delete a[i][e], a[i]._visualValues !== void 0 && a[i]._visualValues[e] !== void 0 && delete a[i]._visualValues[e];
    }
  }
}
const ie = (o) => o === "reset" || o === "none", Be = (o, t) => t ? o : Object.assign({}, o), Ks = (o, t, e) => o && !t.hidden && t._stacked && {
  keys: Li(e, !0),
  values: null
};
class qt {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = te(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && _t(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, i = this.getDataset(), s = (d, u, g, f) => d === "x" ? u : d === "r" ? f : g, a = e.xAxisID = P(i.xAxisID, ee(t, "x")), n = e.yAxisID = P(i.yAxisID, ee(t, "y")), r = e.rAxisID = P(i.rAxisID, ee(t, "r")), h = e.indexAxis, l = e.iAxisID = s(h, a, n, r), c = e.vAxisID = s(h, n, a, r);
    e.xScale = this.getScaleForId(a), e.yScale = this.getScaleForId(n), e.rScale = this.getScaleForId(r), e.iScale = this.getScaleForId(l), e.vScale = this.getScaleForId(c);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ve(this._data, this), t._stacked && _t(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), i = this._data;
    if (E(e)) {
      const s = this._cachedMeta;
      this._data = Ns(e, s);
    } else if (i !== e) {
      if (i) {
        ve(i, this);
        const s = this._cachedMeta;
        _t(s), s._parsed = [];
      }
      e && Object.isExtensible(e) && ts(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, i = this.getDataset();
    let s = !1;
    this._dataCheck();
    const a = e._stacked;
    e._stacked = te(e.vScale, e), e.stack !== i.stack && (s = !0, _t(e), e.stack = i.stack), this._resyncElements(t), (s || a !== e._stacked) && (Fe(this, e._parsed), e._stacked = te(e.vScale, e));
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: i, _data: s } = this, { iScale: a, _stacked: n } = i, r = a.axis;
    let h = t === 0 && e === s.length ? !0 : i._sorted, l = t > 0 && i._parsed[t - 1], c, d, u;
    if (this._parsing === !1)
      i._parsed = s, i._sorted = !0, u = s;
    else {
      V(s[t]) ? u = this.parseArrayData(i, s, t, e) : E(s[t]) ? u = this.parseObjectData(i, s, t, e) : u = this.parsePrimitiveData(i, s, t, e);
      const g = () => d[r] === null || l && d[r] < l[r];
      for (c = 0; c < e; ++c)
        i._parsed[c + t] = d = u[c], h && (g() && (h = !1), l = d);
      i._sorted = h;
    }
    n && Fe(this, u);
  }
  parsePrimitiveData(t, e, i, s) {
    const { iScale: a, vScale: n } = t, r = a.axis, h = n.axis, l = a.getLabels(), c = a === n, d = new Array(s);
    let u, g, f;
    for (u = 0, g = s; u < g; ++u)
      f = u + i, d[u] = {
        [r]: c || a.parse(l[f], f),
        [h]: n.parse(e[f], f)
      };
    return d;
  }
  parseArrayData(t, e, i, s) {
    const { xScale: a, yScale: n } = t, r = new Array(s);
    let h, l, c, d;
    for (h = 0, l = s; h < l; ++h)
      c = h + i, d = e[c], r[h] = {
        x: a.parse(d[0], c),
        y: n.parse(d[1], c)
      };
    return r;
  }
  parseObjectData(t, e, i, s) {
    const { xScale: a, yScale: n } = t, { xAxisKey: r = "x", yAxisKey: h = "y" } = this._parsing, l = new Array(s);
    let c, d, u, g;
    for (c = 0, d = s; c < d; ++c)
      u = c + i, g = e[u], l[c] = {
        x: a.parse(ut(g, r), u),
        y: n.parse(ut(g, h), u)
      };
    return l;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, i) {
    const s = this.chart, a = this._cachedMeta, n = e[t.axis], r = {
      keys: Li(s, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return Re(r, n, a.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, e, i, s) {
    const a = i[e.axis];
    let n = a === null ? NaN : a;
    const r = s && i._stacks[e.axis];
    s && r && (s.values = r, n = Re(s, a, this._cachedMeta.index)), t.min = Math.min(t.min, n), t.max = Math.max(t.max, n);
  }
  getMinMax(t, e) {
    const i = this._cachedMeta, s = i._parsed, a = i._sorted && t === i.iScale, n = s.length, r = this._getOtherScale(t), h = Ks(e, i, this.chart), l = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: c, max: d } = Us(r);
    let u, g;
    function f() {
      g = s[u];
      const p = g[r.axis];
      return !N(g[t.axis]) || c > p || d < p;
    }
    for (u = 0; u < n && !(!f() && (this.updateRangeFromParsed(l, t, g, h), a)); ++u)
      ;
    if (a) {
      for (u = n - 1; u >= 0; --u)
        if (!f()) {
          this.updateRangeFromParsed(l, t, g, h);
          break;
        }
    }
    return l;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, i = [];
    let s, a, n;
    for (s = 0, a = e.length; s < a; ++s)
      n = e[s][t.axis], N(n) && i.push(n);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = e.iScale, s = e.vScale, a = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(a[i.axis]) : "",
      value: s ? "" + s.getLabelForValue(a[s.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = Ws(P(this.options.clip, Hs(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, i = this._cachedMeta, s = i.data || [], a = e.chartArea, n = [], r = this._drawStart || 0, h = this._drawCount || s.length - r, l = this.options.drawActiveElementsOnTop;
    let c;
    for (i.dataset && i.dataset.draw(t, a, r, h), c = r; c < r + h; ++c) {
      const d = s[c];
      d.hidden || (d.active && l ? n.push(d) : d.draw(t, a));
    }
    for (c = 0; c < n.length; ++c)
      n[c].draw(t, a);
  }
  getStyle(t, e) {
    const i = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, e, i) {
    const s = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const n = this._cachedMeta.data[t];
      a = n.$context || (n.$context = qs(this.getContext(), t, n)), a.parsed = this.getParsed(t), a.raw = s.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = Xs(this.chart.getContext(), this.index)), a.dataset = s, a.index = a.datasetIndex = this.index;
    return a.active = !!e, a.mode = i, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", i) {
    const s = e === "active", a = this._cachedDataOpts, n = t + "-" + e, r = a[n], h = this.enableOptionSharing && St(i);
    if (r)
      return Be(r, h);
    const l = this.chart.config, c = l.datasetElementScopeKeys(this._type, t), d = s ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], u = l.getOptionScopes(this.getDataset(), c), g = Object.keys(z.elements[t]), f = () => this.getContext(i, s, e), p = l.resolveNamedOptions(u, g, f, d);
    return p.$shared && (p.$shared = h, a[n] = Object.freeze(Be(p, h))), p;
  }
  _resolveAnimations(t, e, i) {
    const s = this.chart, a = this._cachedDataOpts, n = `animation-${e}`, r = a[n];
    if (r)
      return r;
    let h;
    if (s.options.animation !== !1) {
      const c = this.chart.config, d = c.datasetAnimationScopeKeys(this._type, e), u = c.getOptionScopes(this.getDataset(), d);
      h = c.createResolver(u, this.getContext(t, i, e));
    }
    const l = new Oi(s, h && h.animations);
    return h && h._cacheable && (a[n] = Object.freeze(l)), l;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || ie(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const i = this.resolveDataElementOptions(t, e), s = this._sharedOptions, a = this.getSharedOptions(i), n = this.includeOptions(e, a) || a !== s;
    return this.updateSharedOptions(a, e, i), {
      sharedOptions: a,
      includeOptions: n
    };
  }
  updateElement(t, e, i, s) {
    ie(s) ? Object.assign(t, i) : this._resolveAnimations(e, s).update(t, i);
  }
  updateSharedOptions(t, e, i) {
    t && !ie(e) && this._resolveAnimations(void 0, e).update(t, i);
  }
  _setStyle(t, e, i, s) {
    t.active = s;
    const a = this.getStyle(e, s);
    this._resolveAnimations(e, i, s).update(t, {
      options: !s && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, i = this._cachedMeta.data;
    for (const [r, h, l] of this._syncList)
      this[r](h, l);
    this._syncList = [];
    const s = i.length, a = e.length, n = Math.min(a, s);
    n && this.parse(0, n), a > s ? this._insertElements(s, a - s, t) : a < s && this._removeElements(a, s - a);
  }
  _insertElements(t, e, i = !0) {
    const s = this._cachedMeta, a = s.data, n = t + e;
    let r;
    const h = (l) => {
      for (l.length += e, r = l.length - 1; r >= n; r--)
        l[r] = l[r - e];
    };
    for (h(a), r = t; r < n; ++r)
      a[r] = new this.dataElementType();
    this._parsing && h(s._parsed), this.parse(t, e), i && this.updateElements(a, t, e, "reset");
  }
  updateElements(t, e, i, s) {
  }
  _removeElements(t, e) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const s = i._parsed.splice(t, e);
      i._stacked && _t(i, s);
    }
    i.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, i, s] = t;
      this[e](i, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
function Gs(o, t) {
  if (!o._cache.$bar) {
    const e = o.getMatchingVisibleMetas(t);
    let i = [];
    for (let s = 0, a = e.length; s < a; s++)
      i = i.concat(e[s].controller.getAllParsedValues(o));
    o._cache.$bar = ks(i.sort((s, a) => s - a));
  }
  return o._cache.$bar;
}
function Js(o) {
  const t = o.iScale, e = Gs(t, o.type);
  let i = t._length, s, a, n, r;
  const h = () => {
    n === 32767 || n === -32768 || (St(r) && (i = Math.min(i, Math.abs(n - r) || i)), r = n);
  };
  for (s = 0, a = e.length; s < a; ++s)
    n = t.getPixelForValue(e[s]), h();
  for (r = void 0, s = 0, a = t.ticks.length; s < a; ++s)
    n = t.getPixelForTick(s), h();
  return i;
}
function Zs(o, t, e, i) {
  const s = e.barThickness;
  let a, n;
  return L(s) ? (a = t.min * e.categoryPercentage, n = e.barPercentage) : (a = s * i, n = 1), {
    chunk: a / i,
    ratio: n,
    start: t.pixels[o] - a / 2
  };
}
function Qs(o, t, e, i) {
  const s = t.pixels, a = s[o];
  let n = o > 0 ? s[o - 1] : null, r = o < s.length - 1 ? s[o + 1] : null;
  const h = e.categoryPercentage;
  n === null && (n = a - (r === null ? t.end - t.start : r - a)), r === null && (r = a + a - n);
  const l = a - (a - Math.min(n, r)) / 2 * h;
  return {
    chunk: Math.abs(r - n) / 2 * h / i,
    ratio: e.barPercentage,
    start: l
  };
}
function to(o, t, e, i) {
  const s = e.parse(o[0], i), a = e.parse(o[1], i), n = Math.min(s, a), r = Math.max(s, a);
  let h = n, l = r;
  Math.abs(n) > Math.abs(r) && (h = r, l = n), t[e.axis] = l, t._custom = {
    barStart: h,
    barEnd: l,
    start: s,
    end: a,
    min: n,
    max: r
  };
}
function Ei(o, t, e, i) {
  return V(o) ? to(o, t, e, i) : t[e.axis] = e.parse(o, i), t;
}
function Ve(o, t, e, i) {
  const s = o.iScale, a = o.vScale, n = s.getLabels(), r = s === a, h = [];
  let l, c, d, u;
  for (l = e, c = e + i; l < c; ++l)
    u = t[l], d = {}, d[s.axis] = r || s.parse(n[l], l), h.push(Ei(u, d, a, l));
  return h;
}
function se(o) {
  return o && o.barStart !== void 0 && o.barEnd !== void 0;
}
function eo(o, t, e) {
  return o !== 0 ? et(o) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function io(o) {
  let t, e, i, s, a;
  return o.horizontal ? (t = o.base > o.x, e = "left", i = "right") : (t = o.base < o.y, e = "bottom", i = "top"), t ? (s = "end", a = "start") : (s = "start", a = "end"), {
    start: e,
    end: i,
    reverse: t,
    top: s,
    bottom: a
  };
}
function so(o, t, e, i) {
  let s = t.borderSkipped;
  const a = {};
  if (!s) {
    o.borderSkipped = a;
    return;
  }
  if (s === !0) {
    o.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: n, end: r, reverse: h, top: l, bottom: c } = io(o);
  s === "middle" && e && (o.enableBorderRadius = !0, (e._top || 0) === i ? s = l : (e._bottom || 0) === i ? s = c : (a[He(c, n, r, h)] = !0, s = l)), a[He(s, n, r, h)] = !0, o.borderSkipped = a;
}
function He(o, t, e, i) {
  return i ? (o = oo(o, t, e), o = We(o, e, t)) : o = We(o, t, e), o;
}
function oo(o, t, e) {
  return o === t ? e : o === e ? t : o;
}
function We(o, t, e) {
  return o === "start" ? t : o === "end" ? e : o;
}
function ao(o, { inflateAmount: t }, e) {
  o.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class xn extends qt {
  static id = "bar";
  static defaults = {
    datasetElementType: !1,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: !0,
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "base",
          "width",
          "height"
        ]
      }
    }
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category",
        offset: !0,
        grid: {
          offset: !0
        }
      },
      _value_: {
        type: "linear",
        beginAtZero: !0
      }
    }
  };
  parsePrimitiveData(t, e, i, s) {
    return Ve(t, e, i, s);
  }
  parseArrayData(t, e, i, s) {
    return Ve(t, e, i, s);
  }
  parseObjectData(t, e, i, s) {
    const { iScale: a, vScale: n } = t, { xAxisKey: r = "x", yAxisKey: h = "y" } = this._parsing, l = a.axis === "x" ? r : h, c = n.axis === "x" ? r : h, d = [];
    let u, g, f, p;
    for (u = i, g = i + s; u < g; ++u)
      p = e[u], f = {}, f[a.axis] = a.parse(ut(p, l), u), d.push(Ei(ut(p, c), f, n, u));
    return d;
  }
  updateRangeFromParsed(t, e, i, s) {
    super.updateRangeFromParsed(t, e, i, s);
    const a = i._custom;
    a && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: i, vScale: s } = e, a = this.getParsed(t), n = a._custom, r = se(n) ? "[" + n.start + ", " + n.end + "]" : "" + s.getLabelForValue(a[s.axis]);
    return {
      label: "" + i.getLabelForValue(a[i.axis]),
      value: r
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", { index: n, _cachedMeta: { vScale: r } } = this, h = r.getBasePixel(), l = r.isHorizontal(), c = this._getRuler(), { sharedOptions: d, includeOptions: u } = this._getSharedOptions(e, s);
    for (let g = e; g < e + i; g++) {
      const f = this.getParsed(g), p = a || L(f[r.axis]) ? {
        base: h,
        head: h
      } : this._calculateBarValuePixels(g), m = this._calculateBarIndexPixels(g, c), x = (f._stacks || {})[r.axis], v = {
        horizontal: l,
        base: p.base,
        enableBorderRadius: !x || se(f._custom) || n === x._top || n === x._bottom,
        x: l ? p.head : m.center,
        y: l ? m.center : p.head,
        height: l ? m.size : Math.abs(p.size),
        width: l ? Math.abs(p.size) : m.size
      };
      u && (v.options = d || this.resolveDataElementOptions(g, t[g].active ? "active" : s));
      const y = v.options || t[g].options;
      so(v, y, x, n), ao(v, y, c.ratio), this.updateElement(t[g], g, v, s);
    }
  }
  _getStacks(t, e) {
    const { iScale: i } = this._cachedMeta, s = i.getMatchingVisibleMetas(this._type).filter((c) => c.controller.options.grouped), a = i.options.stacked, n = [], r = this._cachedMeta.controller.getParsed(e), h = r && r[i.axis], l = (c) => {
      const d = c._parsed.find((g) => g[i.axis] === h), u = d && d[c.vScale.axis];
      if (L(u) || isNaN(u))
        return !0;
    };
    for (const c of s)
      if (!(e !== void 0 && l(c)) && ((a === !1 || n.indexOf(c.stack) === -1 || a === void 0 && c.stack === void 0) && n.push(c.stack), c.index === t))
        break;
    return n.length || n.push(void 0), n;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getAxisCount() {
    return this._getAxis().length;
  }
  getFirstScaleIdForIndexAxis() {
    const t = this.chart.scales, e = this.chart.options.indexAxis;
    return Object.keys(t).filter((i) => t[i].axis === e).shift();
  }
  _getAxis() {
    const t = {}, e = this.getFirstScaleIdForIndexAxis();
    for (const i of this.chart.data.datasets)
      t[P(this.chart.options.indexAxis === "x" ? i.xAxisID : i.yAxisID, e)] = !0;
    return Object.keys(t);
  }
  _getStackIndex(t, e, i) {
    const s = this._getStacks(t, i), a = e !== void 0 ? s.indexOf(e) : -1;
    return a === -1 ? s.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, i = e.iScale, s = [];
    let a, n;
    for (a = 0, n = e.data.length; a < n; ++a)
      s.push(i.getPixelForValue(this.getParsed(a)[i.axis], a));
    const r = t.barThickness;
    return {
      min: r || Js(e),
      pixels: s,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: t.grouped,
      ratio: r ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: i, index: s }, options: { base: a, minBarLength: n } } = this, r = a || 0, h = this.getParsed(t), l = h._custom, c = se(l);
    let d = h[e.axis], u = 0, g = i ? this.applyStack(e, h, i) : d, f, p;
    g !== d && (u = g - d, g = d), c && (d = l.barStart, g = l.barEnd - l.barStart, d !== 0 && et(d) !== et(l.barEnd) && (u = 0), u += d);
    const m = !L(a) && !c ? a : u;
    let x = e.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? f = e.getPixelForValue(u + g) : f = x, p = f - x, Math.abs(p) < n) {
      p = eo(p, e, r) * n, d === r && (x -= p / 2);
      const v = e.getPixelForDecimal(0), y = e.getPixelForDecimal(1), _ = Math.min(v, y), b = Math.max(v, y);
      x = Math.max(Math.min(x, b), _), f = x + p, i && !c && (h._stacks[e.axis]._visualValues[s] = e.getValueForPixel(f) - e.getValueForPixel(x));
    }
    if (x === e.getPixelForValue(r)) {
      const v = et(p) * e.getLineWidthForValue(r) / 2;
      x += v, p -= v;
    }
    return {
      size: p,
      base: x,
      head: f,
      center: f + p / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const i = e.scale, s = this.options, a = s.skipNull, n = P(s.maxBarThickness, 1 / 0);
    let r, h;
    const l = this._getAxisCount();
    if (e.grouped) {
      const c = a ? this._getStackCount(t) : e.stackCount, d = s.barThickness === "flex" ? Qs(t, e, s, c * l) : Zs(t, e, s, c * l), u = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, g = this._getAxis().indexOf(P(u, this.getFirstScaleIdForIndexAxis())), f = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0) + g;
      r = d.start + d.chunk * f + d.chunk / 2, h = Math.min(n, d.chunk * d.ratio);
    } else
      r = i.getPixelForValue(this.getParsed(t)[i.axis], t), h = Math.min(n, e.min * e.ratio);
    return {
      base: r - h / 2,
      head: r + h / 2,
      center: r,
      size: h
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, i = t.data, s = i.length;
    let a = 0;
    for (; a < s; ++a)
      this.getParsed(a)[e.axis] !== null && !i[a].hidden && i[a].draw(this._ctx);
  }
}
function no(o, t, e) {
  let i = 1, s = 1, a = 0, n = 0;
  if (t < lt) {
    const r = o, h = r + t, l = Math.cos(r), c = Math.sin(r), d = Math.cos(h), u = Math.sin(h), g = (y, _, b) => ge(y, r, h, !0) ? 1 : Math.max(_, _ * e, b, b * e), f = (y, _, b) => ge(y, r, h, !0) ? -1 : Math.min(_, _ * e, b, b * e), p = g(0, l, d), m = g(Nt, c, u), x = f(Wt, l, d), v = f(Wt + Nt, c, u);
    i = (p - x) / 2, s = (m - v) / 2, a = -(p + x) / 2, n = -(m + v) / 2;
  }
  return {
    ratioX: i,
    ratioY: s,
    offsetX: a,
    offsetY: n
  };
}
class mn extends qt {
  static id = "doughnut";
  static defaults = {
    datasetElementType: !1,
    dataElementType: "arc",
    animation: {
      animateRotate: !0,
      animateScale: !1
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "circumference",
          "endAngle",
          "innerRadius",
          "outerRadius",
          "startAngle",
          "x",
          "y",
          "offset",
          "borderWidth",
          "spacing"
        ]
      }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
  };
  static descriptors = {
    _scriptable: (t) => t !== "spacing",
    _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
  };
  static overrides = {
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          generateLabels(t) {
            const e = t.data;
            if (e.labels.length && e.datasets.length) {
              const { labels: { pointStyle: i, color: s } } = t.legend.options;
              return e.labels.map((a, n) => {
                const r = t.getDatasetMeta(0).controller.getStyle(n);
                return {
                  text: a,
                  fillStyle: r.backgroundColor,
                  strokeStyle: r.borderColor,
                  fontColor: s,
                  lineWidth: r.borderWidth,
                  pointStyle: i,
                  hidden: !t.getDataVisibility(n),
                  index: n
                };
              });
            }
            return [];
          }
        },
        onClick(t, e, i) {
          i.chart.toggleDataVisibility(e.index), i.chart.update();
        }
      }
    }
  };
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const i = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = i;
    else {
      let a = (h) => +i[h];
      if (E(i[t])) {
        const { key: h = "value" } = this._parsing;
        a = (l) => +ut(i[l], h);
      }
      let n, r;
      for (n = t, r = t + e; n < r; ++n)
        s._parsed[n] = a(n);
    }
  }
  _getRotation() {
    return Z(this.options.rotation - 90);
  }
  _getCircumference() {
    return Z(this.options.circumference);
  }
  _getRotationExtents() {
    let t = lt, e = -lt;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const s = this.chart.getDatasetMeta(i).controller, a = s._getRotation(), n = s._getCircumference();
        t = Math.min(t, a), e = Math.max(e, a + n);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: i } = e, s = this._cachedMeta, a = s.data, n = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, r = Math.max((Math.min(i.width, i.height) - n) / 2, 0), h = Math.min(Zi(this.options.cutout, r), 1), l = this._getRingWeight(this.index), { circumference: c, rotation: d } = this._getRotationExtents(), { ratioX: u, ratioY: g, offsetX: f, offsetY: p } = no(d, c, h), m = (i.width - n) / u, x = (i.height - n) / g, v = Math.max(Math.min(m, x) / 2, 0), y = Qi(this.options.radius, v), _ = Math.max(y * h, 0), b = (y - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = f * y, this.offsetY = p * y, s.total = this.calculateTotal(), this.outerRadius = y - b * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - b * l, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, e) {
    const i = this.options, s = this._cachedMeta, a = this._getCircumference();
    return e && i.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * a / lt);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", n = this.chart, r = n.chartArea, h = n.options.animation, l = (r.left + r.right) / 2, c = (r.top + r.bottom) / 2, d = a && h.animateScale, u = d ? 0 : this.innerRadius, g = d ? 0 : this.outerRadius, { sharedOptions: f, includeOptions: p } = this._getSharedOptions(e, s);
    let m = this._getRotation(), x;
    for (x = 0; x < e; ++x)
      m += this._circumference(x, a);
    for (x = e; x < e + i; ++x) {
      const v = this._circumference(x, a), y = t[x], _ = {
        x: l + this.offsetX,
        y: c + this.offsetY,
        startAngle: m,
        endAngle: m + v,
        circumference: v,
        outerRadius: g,
        innerRadius: u
      };
      p && (_.options = f || this.resolveDataElementOptions(x, y.active ? "active" : s)), m += v, this.updateElement(y, x, _, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let i = 0, s;
    for (s = 0; s < e.length; s++) {
      const a = t._parsed[s];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(s) && !e[s].hidden && (i += Math.abs(a));
    }
    return i;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? lt * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart, s = i.data.labels || [], a = ki(e._parsed[t], i.options.locale);
    return {
      label: s[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const i = this.chart;
    let s, a, n, r, h;
    if (!t) {
      for (s = 0, a = i.data.datasets.length; s < a; ++s)
        if (i.isDatasetVisible(s)) {
          n = i.getDatasetMeta(s), t = n.data, r = n.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, a = t.length; s < a; ++s)
      h = r.resolveDataElementOptions(s), h.borderAlign !== "inner" && (e = Math.max(e, h.borderWidth || 0, h.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let i = 0, s = t.length; i < s; ++i) {
      const a = this.resolveDataElementOptions(i);
      e = Math.max(e, a.offset || 0, a.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (e += this._getRingWeight(i));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(P(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
class _n extends qt {
  static id = "line";
  static defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: !0,
    spanGaps: !1
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category"
      },
      _value_: {
        type: "linear"
      }
    }
  };
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: i, data: s = [], _dataset: a } = e, n = this.chart._animationsDisabled;
    let { start: r, count: h } = as(e, s, n);
    this._drawStart = r, this._drawCount = h, ns(e) && (r = 0, h = s.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!a._decimated, i.points = s;
    const l = this.resolveDatasetElementOptions(t);
    this.options.showLine || (l.borderWidth = 0), l.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !n,
      options: l
    }, t), this.updateElements(s, r, h, t);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", { iScale: n, vScale: r, _stacked: h, _dataset: l } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(e, s), u = n.axis, g = r.axis, { spanGaps: f, segment: p } = this.options, m = de(f) ? f : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || a || s === "none", v = e + i, y = t.length;
    let _ = e > 0 && this.getParsed(e - 1);
    for (let b = 0; b < y; ++b) {
      const M = t[b], k = x ? M : {};
      if (b < e || b >= v) {
        k.skip = !0;
        continue;
      }
      const w = this.getParsed(b), O = L(w[g]), S = k[u] = n.getPixelForValue(w[u], b), D = k[g] = a || O ? r.getBasePixel() : r.getPixelForValue(h ? this.applyStack(r, w, h) : w[g], b);
      k.skip = isNaN(S) || isNaN(D) || O, k.stop = b > 0 && Math.abs(w[u] - _[u]) > m, p && (k.parsed = w, k.raw = l.data[b]), d && (k.options = c || this.resolveDataElementOptions(b, M.active ? "active" : s)), x || this.updateElement(M, b, k, s), _ = w;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, i = e.options && e.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return i;
    const a = s[0].size(this.resolveDataElementOptions(0)), n = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(i, a, n) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
function ro(o, t, e, i) {
  const { controller: s, data: a, _sorted: n } = o, r = s._cachedMeta.iScale, h = o.dataset && o.dataset.options ? o.dataset.options.spanGaps : null;
  if (r && t === r.axis && t !== "r" && n && a.length) {
    const l = r._reversePixels ? Os : Ls;
    if (i) {
      if (s._sharedOptions) {
        const c = a[0], d = typeof c.getRange == "function" && c.getRange(t);
        if (d) {
          const u = l(a, t, e - d), g = l(a, t, e + d);
          return {
            lo: u.lo,
            hi: g.hi
          };
        }
      }
    } else {
      const c = l(a, t, e);
      if (h) {
        const { vScale: d } = s._cachedMeta, { _parsed: u } = o, g = u.slice(0, c.lo + 1).reverse().findIndex((p) => !L(p[d.axis]));
        c.lo -= Math.max(0, g);
        const f = u.slice(c.hi).findIndex((p) => !L(p[d.axis]));
        c.hi += Math.max(0, f);
      }
      return c;
    }
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function Kt(o, t, e, i, s) {
  const a = o.getSortedVisibleDatasetMetas(), n = e[t];
  for (let r = 0, h = a.length; r < h; ++r) {
    const { index: l, data: c } = a[r], { lo: d, hi: u } = ro(a[r], t, n, s);
    for (let g = d; g <= u; ++g) {
      const f = c[g];
      f.skip || i(f, l, g);
    }
  }
}
function ho(o) {
  const t = o.indexOf("x") !== -1, e = o.indexOf("y") !== -1;
  return function(i, s) {
    const a = t ? Math.abs(i.x - s.x) : 0, n = e ? Math.abs(i.y - s.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
  };
}
function oe(o, t, e, i, s) {
  const a = [];
  return !s && !o.isPointInArea(t) || Kt(o, e, t, function(n, r, h) {
    !s && !_e(n, o.chartArea, 0) || n.inRange(t.x, t.y, i) && a.push({
      element: n,
      datasetIndex: r,
      index: h
    });
  }, !0), a;
}
function lo(o, t, e, i) {
  let s = [];
  function a(n, r, h) {
    const { startAngle: l, endAngle: c } = n.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: d } = Es(n, {
      x: t.x,
      y: t.y
    });
    ge(d, l, c) && s.push({
      element: n,
      datasetIndex: r,
      index: h
    });
  }
  return Kt(o, e, t, a), s;
}
function co(o, t, e, i, s, a) {
  let n = [];
  const r = ho(e);
  let h = Number.POSITIVE_INFINITY;
  function l(c, d, u) {
    const g = c.inRange(t.x, t.y, s);
    if (i && !g)
      return;
    const f = c.getCenterPoint(s);
    if (!(a || o.isPointInArea(f)) && !g)
      return;
    const p = r(t, f);
    p < h ? (n = [
      {
        element: c,
        datasetIndex: d,
        index: u
      }
    ], h = p) : p === h && n.push({
      element: c,
      datasetIndex: d,
      index: u
    });
  }
  return Kt(o, e, t, l), n;
}
function ae(o, t, e, i, s, a) {
  return !a && !o.isPointInArea(t) ? [] : e === "r" && !i ? lo(o, t, e, s) : co(o, t, e, i, s, a);
}
function Ne(o, t, e, i, s) {
  const a = [], n = e === "x" ? "inXRange" : "inYRange";
  let r = !1;
  return Kt(o, e, t, (h, l, c) => {
    h[n] && h[n](t[e], s) && (a.push({
      element: h,
      datasetIndex: l,
      index: c
    }), r = r || h.inRange(t.x, t.y, s));
  }), i && !r ? [] : a;
}
var uo = {
  modes: {
    index(o, t, e, i) {
      const s = at(t, o), a = e.axis || "x", n = e.includeInvisible || !1, r = e.intersect ? oe(o, s, a, i, n) : ae(o, s, a, !1, i, n), h = [];
      return r.length ? (o.getSortedVisibleDatasetMetas().forEach((l) => {
        const c = r[0].index, d = l.data[c];
        d && !d.skip && h.push({
          element: d,
          datasetIndex: l.index,
          index: c
        });
      }), h) : [];
    },
    dataset(o, t, e, i) {
      const s = at(t, o), a = e.axis || "xy", n = e.includeInvisible || !1;
      let r = e.intersect ? oe(o, s, a, i, n) : ae(o, s, a, !1, i, n);
      if (r.length > 0) {
        const h = r[0].datasetIndex, l = o.getDatasetMeta(h).data;
        r = [];
        for (let c = 0; c < l.length; ++c)
          r.push({
            element: l[c],
            datasetIndex: h,
            index: c
          });
      }
      return r;
    },
    point(o, t, e, i) {
      const s = at(t, o), a = e.axis || "xy", n = e.includeInvisible || !1;
      return oe(o, s, a, i, n);
    },
    nearest(o, t, e, i) {
      const s = at(t, o), a = e.axis || "xy", n = e.includeInvisible || !1;
      return ae(o, s, a, e.intersect, i, n);
    },
    x(o, t, e, i) {
      const s = at(t, o);
      return Ne(o, s, "x", e.intersect, i);
    },
    y(o, t, e, i) {
      const s = at(t, o);
      return Ne(o, s, "y", e.intersect, i);
    }
  }
};
const zi = [
  "left",
  "top",
  "right",
  "bottom"
];
function bt(o, t) {
  return o.filter((e) => e.pos === t);
}
function je(o, t) {
  return o.filter((e) => zi.indexOf(e.pos) === -1 && e.box.axis === t);
}
function yt(o, t) {
  return o.sort((e, i) => {
    const s = t ? i : e, a = t ? e : i;
    return s.weight === a.weight ? s.index - a.index : s.weight - a.weight;
  });
}
function go(o) {
  const t = [];
  let e, i, s, a, n, r;
  for (e = 0, i = (o || []).length; e < i; ++e)
    s = o[e], { position: a, options: { stack: n, stackWeight: r = 1 } } = s, t.push({
      index: e,
      box: s,
      pos: a,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: n && a + n,
      stackWeight: r
    });
  return t;
}
function fo(o) {
  const t = {};
  for (const e of o) {
    const { stack: i, pos: s, stackWeight: a } = e;
    if (!i || !zi.includes(s))
      continue;
    const n = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    n.count++, n.weight += a;
  }
  return t;
}
function po(o, t) {
  const e = fo(o), { vBoxMaxWidth: i, hBoxMaxHeight: s } = t;
  let a, n, r;
  for (a = 0, n = o.length; a < n; ++a) {
    r = o[a];
    const { fullSize: h } = r.box, l = e[r.stack], c = l && r.stackWeight / l.weight;
    r.horizontal ? (r.width = c ? c * i : h && t.availableWidth, r.height = s) : (r.width = i, r.height = c ? c * s : h && t.availableHeight);
  }
  return e;
}
function xo(o) {
  const t = go(o), e = yt(t.filter((l) => l.box.fullSize), !0), i = yt(bt(t, "left"), !0), s = yt(bt(t, "right")), a = yt(bt(t, "top"), !0), n = yt(bt(t, "bottom")), r = je(t, "x"), h = je(t, "y");
  return {
    fullSize: e,
    leftAndTop: i.concat(a),
    rightAndBottom: s.concat(h).concat(n).concat(r),
    chartArea: bt(t, "chartArea"),
    vertical: i.concat(s).concat(h),
    horizontal: a.concat(n).concat(r)
  };
}
function Ue(o, t, e, i) {
  return Math.max(o[e], t[e]) + Math.max(o[i], t[i]);
}
function Ri(o, t) {
  o.top = Math.max(o.top, t.top), o.left = Math.max(o.left, t.left), o.bottom = Math.max(o.bottom, t.bottom), o.right = Math.max(o.right, t.right);
}
function mo(o, t, e, i) {
  const { pos: s, box: a } = e, n = o.maxPadding;
  if (!E(s)) {
    e.size && (o[s] -= e.size);
    const d = i[e.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, e.horizontal ? a.height : a.width), e.size = d.size / d.count, o[s] += e.size;
  }
  a.getPadding && Ri(n, a.getPadding());
  const r = Math.max(0, t.outerWidth - Ue(n, o, "left", "right")), h = Math.max(0, t.outerHeight - Ue(n, o, "top", "bottom")), l = r !== o.w, c = h !== o.h;
  return o.w = r, o.h = h, e.horizontal ? {
    same: l,
    other: c
  } : {
    same: c,
    other: l
  };
}
function _o(o) {
  const t = o.maxPadding;
  function e(i) {
    const s = Math.max(t[i] - o[i], 0);
    return o[i] += s, s;
  }
  o.y += e("top"), o.x += e("left"), e("right"), e("bottom");
}
function bo(o, t) {
  const e = t.maxPadding;
  function i(s) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((n) => {
      a[n] = Math.max(t[n], e[n]);
    }), a;
  }
  return i(o ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Mt(o, t, e, i) {
  const s = [];
  let a, n, r, h, l, c;
  for (a = 0, n = o.length, l = 0; a < n; ++a) {
    r = o[a], h = r.box, h.update(r.width || t.w, r.height || t.h, bo(r.horizontal, t));
    const { same: d, other: u } = mo(t, e, r, i);
    l |= d && s.length, c = c || u, h.fullSize || s.push(r);
  }
  return l && Mt(s, t, e, i) || c;
}
function Lt(o, t, e, i, s) {
  o.top = e, o.left = t, o.right = t + i, o.bottom = e + s, o.width = i, o.height = s;
}
function Ye(o, t, e, i) {
  const s = e.padding;
  let { x: a, y: n } = t;
  for (const r of o) {
    const h = r.box, l = i[r.stack] || {
      placed: 0,
      weight: 1
    }, c = r.stackWeight / l.weight || 1;
    if (r.horizontal) {
      const d = t.w * c, u = l.size || h.height;
      St(l.start) && (n = l.start), h.fullSize ? Lt(h, s.left, n, e.outerWidth - s.right - s.left, u) : Lt(h, t.left + l.placed, n, d, u), l.start = n, l.placed += d, n = h.bottom;
    } else {
      const d = t.h * c, u = l.size || h.width;
      St(l.start) && (a = l.start), h.fullSize ? Lt(h, a, s.top, u, e.outerHeight - s.bottom - s.top) : Lt(h, a, t.top + l.placed, u, d), l.start = a, l.placed += d, a = h.right;
    }
  }
  t.x = a, t.y = n;
}
var H = {
  addBox(o, t) {
    o.boxes || (o.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, o.boxes.push(t);
  },
  removeBox(o, t) {
    const e = o.boxes ? o.boxes.indexOf(t) : -1;
    e !== -1 && o.boxes.splice(e, 1);
  },
  configure(o, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(o, t, e, i) {
    if (!o)
      return;
    const s = W(o.options.layout.padding), a = Math.max(t - s.width, 0), n = Math.max(e - s.height, 0), r = xo(o.boxes), h = r.vertical, l = r.horizontal;
    C(o.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const c = h.reduce((p, m) => m.box.options && m.box.options.display === !1 ? p : p + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: s,
      availableWidth: a,
      availableHeight: n,
      vBoxMaxWidth: a / 2 / c,
      hBoxMaxHeight: n / 2
    }), u = Object.assign({}, s);
    Ri(u, W(i));
    const g = Object.assign({
      maxPadding: u,
      w: a,
      h: n,
      x: s.left,
      y: s.top
    }, s), f = po(h.concat(l), d);
    Mt(r.fullSize, g, d, f), Mt(h, g, d, f), Mt(l, g, d, f) && Mt(h, g, d, f), _o(g), Ye(r.leftAndTop, g, d, f), g.x += g.w, g.y += g.h, Ye(r.rightAndBottom, g, d, f), o.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, C(r.chartArea, (p) => {
      const m = p.box;
      Object.assign(m, o.chartArea), m.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class $i {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, i) {
  }
  removeEventListener(t, e, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, i, s) {
    return e = Math.max(0, e || t.width), i = i || t.height, {
      width: e,
      height: Math.max(0, s ? Math.floor(e / s) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class yo extends $i {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Ft = "$chartjs", vo = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Xe = (o) => o === null || o === "";
function wo(o, t) {
  const e = o.style, i = o.getAttribute("height"), s = o.getAttribute("width");
  if (o[Ft] = {
    initial: {
      height: i,
      width: s,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", Xe(s)) {
    const a = Te(o, "width");
    a !== void 0 && (o.width = a);
  }
  if (Xe(i))
    if (o.style.height === "")
      o.height = o.width / (t || 2);
    else {
      const a = Te(o, "height");
      a !== void 0 && (o.height = a);
    }
  return o;
}
const Fi = Ts ? {
  passive: !0
} : !1;
function Mo(o, t, e) {
  o && o.addEventListener(t, e, Fi);
}
function ko(o, t, e) {
  o && o.canvas && o.canvas.removeEventListener(t, e, Fi);
}
function So(o, t) {
  const e = vo[o.type] || o.type, { x: i, y: s } = at(o, t);
  return {
    type: e,
    chart: t,
    native: o,
    x: i !== void 0 ? i : null,
    y: s !== void 0 ? s : null
  };
}
function jt(o, t) {
  for (const e of o)
    if (e === t || e.contains(t))
      return !0;
}
function Do(o, t, e) {
  const i = o.canvas, s = new MutationObserver((a) => {
    let n = !1;
    for (const r of a)
      n = n || jt(r.addedNodes, i), n = n && !jt(r.removedNodes, i);
    n && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function Po(o, t, e) {
  const i = o.canvas, s = new MutationObserver((a) => {
    let n = !1;
    for (const r of a)
      n = n || jt(r.removedNodes, i), n = n && !jt(r.addedNodes, i);
    n && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const Pt = /* @__PURE__ */ new Map();
let qe = 0;
function Bi() {
  const o = window.devicePixelRatio;
  o !== qe && (qe = o, Pt.forEach((t, e) => {
    e.currentDevicePixelRatio !== o && t();
  }));
}
function Ao(o, t) {
  Pt.size || window.addEventListener("resize", Bi), Pt.set(o, t);
}
function Co(o) {
  Pt.delete(o), Pt.size || window.removeEventListener("resize", Bi);
}
function Io(o, t, e) {
  const i = o.canvas, s = i && Ii(i);
  if (!s)
    return;
  const a = Ti((r, h) => {
    const l = s.clientWidth;
    e(r, h), l < s.clientWidth && e();
  }, window), n = new ResizeObserver((r) => {
    const h = r[0], l = h.contentRect.width, c = h.contentRect.height;
    l === 0 && c === 0 || a(l, c);
  });
  return n.observe(s), Ao(o, a), n;
}
function ne(o, t, e) {
  e && e.disconnect(), t === "resize" && Co(o);
}
function To(o, t, e) {
  const i = o.canvas, s = Ti((a) => {
    o.ctx !== null && e(So(a, o));
  }, o);
  return Mo(i, t, s), s;
}
class Oo extends $i {
  acquireContext(t, e) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (wo(t, e), i) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[Ft])
      return !1;
    const i = e[Ft].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const n = i[a];
      L(n) ? e.removeAttribute(a) : e.setAttribute(a, n);
    });
    const s = i.style || {};
    return Object.keys(s).forEach((a) => {
      e.style[a] = s[a];
    }), e.width = e.width, delete e[Ft], !0;
  }
  addEventListener(t, e, i) {
    this.removeEventListener(t, e);
    const s = t.$proxies || (t.$proxies = {}), a = {
      attach: Do,
      detach: Po,
      resize: Io
    }[e] || To;
    s[e] = a(t, e, i);
  }
  removeEventListener(t, e) {
    const i = t.$proxies || (t.$proxies = {}), s = i[e];
    s && (({
      attach: ne,
      detach: ne,
      resize: ne
    }[e] || ko)(t, e, s), i[e] = void 0);
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, i, s) {
    return Ms(t, e, i, s);
  }
  isAttached(t) {
    const e = t && Ii(t);
    return !!(e && e.isConnected);
  }
}
function Lo(o) {
  return !Ci() || typeof OffscreenCanvas < "u" && o instanceof OffscreenCanvas ? yo : Oo;
}
class it {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = !1;
  options;
  $animations;
  tooltipPosition(t) {
    const { x: e, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: i
    };
  }
  hasValue() {
    return de(this.x) && de(this.y);
  }
  getProps(t, e) {
    const i = this.$animations;
    if (!e || !i)
      return this;
    const s = {};
    return t.forEach((a) => {
      s[a] = i[a] && i[a].active() ? i[a]._to : this[a];
    }), s;
  }
}
function Eo(o, t) {
  const e = o.options.ticks, i = zo(o), s = Math.min(e.maxTicksLimit || i, i), a = e.major.enabled ? $o(t) : [], n = a.length, r = a[0], h = a[n - 1], l = [];
  if (n > s)
    return Fo(t, l, a, n / s), l;
  const c = Ro(a, t, s);
  if (n > 0) {
    let d, u;
    const g = n > 1 ? Math.round((h - r) / (n - 1)) : null;
    for (Et(t, l, c, L(g) ? 0 : r - g, r), d = 0, u = n - 1; d < u; d++)
      Et(t, l, c, a[d], a[d + 1]);
    return Et(t, l, c, h, L(g) ? t.length : h + g), l;
  }
  return Et(t, l, c), l;
}
function zo(o) {
  const t = o.options.offset, e = o._tickSize(), i = o._length / e + (t ? 0 : 1), s = o._maxLength / e;
  return Math.floor(Math.min(i, s));
}
function Ro(o, t, e) {
  const i = Bo(o), s = t.length / e;
  if (!i)
    return Math.max(s, 1);
  const a = As(i);
  for (let n = 0, r = a.length - 1; n < r; n++) {
    const h = a[n];
    if (h > s)
      return h;
  }
  return Math.max(s, 1);
}
function $o(o) {
  const t = [];
  let e, i;
  for (e = 0, i = o.length; e < i; e++)
    o[e].major && t.push(e);
  return t;
}
function Fo(o, t, e, i) {
  let s = 0, a = e[0], n;
  for (i = Math.ceil(i), n = 0; n < o.length; n++)
    n === a && (t.push(o[n]), s++, a = e[s * i]);
}
function Et(o, t, e, i, s) {
  const a = P(i, 0), n = Math.min(P(s, o.length), o.length);
  let r = 0, h, l, c;
  for (e = Math.ceil(e), s && (h = s - i, e = h / Math.floor(h / e)), c = a; c < 0; )
    r++, c = Math.round(a + r * e);
  for (l = Math.max(a, 0); l < n; l++)
    l === c && (t.push(o[l]), r++, c = Math.round(a + r * e));
}
function Bo(o) {
  const t = o.length;
  let e, i;
  if (t < 2)
    return !1;
  for (i = o[0], e = 1; e < t; ++e)
    if (o[e] - o[e - 1] !== i)
      return !1;
  return i;
}
const Vo = (o) => o === "left" ? "right" : o === "right" ? "left" : o, Ke = (o, t, e) => t === "top" || t === "left" ? o[t] + e : o[t] - e, Ge = (o, t) => Math.min(t || o, o);
function Je(o, t) {
  const e = [], i = o.length / t, s = o.length;
  let a = 0;
  for (; a < s; a += i)
    e.push(o[Math.floor(a)]);
  return e;
}
function Ho(o, t, e) {
  const i = o.ticks.length, s = Math.min(t, i - 1), a = o._startPixel, n = o._endPixel, r = 1e-6;
  let h = o.getPixelForTick(s), l;
  if (!(e && (i === 1 ? l = Math.max(h - a, n - h) : t === 0 ? l = (o.getPixelForTick(1) - h) / 2 : l = (h - o.getPixelForTick(s - 1)) / 2, h += s < t ? l : -l, h < a - r || h > n + r)))
    return h;
}
function Wo(o, t) {
  C(o, (e) => {
    const i = e.gc, s = i.length / 2;
    let a;
    if (s > t) {
      for (a = 0; a < s; ++a)
        delete e.data[i[a]];
      i.splice(0, s);
    }
  });
}
function vt(o) {
  return o.drawTicks ? o.tickLength : 0;
}
function Ze(o, t) {
  if (!o.display)
    return 0;
  const e = F(o.font, t), i = W(o.padding);
  return (V(o.text) ? o.text.length : 1) * e.lineHeight + i.height;
}
function No(o, t) {
  return ft(o, {
    scale: t,
    type: "scale"
  });
}
function jo(o, t, e) {
  return ft(o, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function Uo(o, t, e) {
  let i = be(o);
  return (e && t !== "right" || !e && t === "right") && (i = Vo(i)), i;
}
function Yo(o, t, e, i) {
  const { top: s, left: a, bottom: n, right: r, chart: h } = o, { chartArea: l, scales: c } = h;
  let d = 0, u, g, f;
  const p = n - s, m = r - a;
  if (o.isHorizontal()) {
    if (g = $(i, a, r), E(e)) {
      const x = Object.keys(e)[0], v = e[x];
      f = c[x].getPixelForValue(v) + p - t;
    } else e === "center" ? f = (l.bottom + l.top) / 2 + p - t : f = Ke(o, e, t);
    u = r - a;
  } else {
    if (E(e)) {
      const x = Object.keys(e)[0], v = e[x];
      g = c[x].getPixelForValue(v) - m + t;
    } else e === "center" ? g = (l.left + l.right) / 2 - m + t : g = Ke(o, e, t);
    f = $(i, n, s), d = e === "left" ? -Nt : Nt;
  }
  return {
    titleX: g,
    titleY: f,
    maxWidth: u,
    rotation: d
  };
}
class At extends it {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: i, _suggestedMax: s } = this;
    return t = Y(t, Number.POSITIVE_INFINITY), e = Y(e, Number.NEGATIVE_INFINITY), i = Y(i, Number.POSITIVE_INFINITY), s = Y(s, Number.NEGATIVE_INFINITY), {
      min: Y(t, i),
      max: Y(e, s),
      minDefined: N(t),
      maxDefined: N(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: i, minDefined: s, maxDefined: a } = this.getUserBounds(), n;
    if (s && a)
      return {
        min: e,
        max: i
      };
    const r = this.getMatchingVisibleMetas();
    for (let h = 0, l = r.length; h < l; ++h)
      n = r[h].controller.getMinMax(this, t), s || (e = Math.min(e, n.min)), a || (i = Math.max(i, n.max));
    return e = a && e > i ? i : e, i = s && e > i ? e : i, {
      min: Y(e, Y(i, e)),
      max: Y(i, Y(e, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    T(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, i) {
    const { beginAtZero: s, grace: a, ticks: n } = this.options, r = n.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = gs(this, a, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const h = r < this.ticks.length;
    this._convertTicksToLabels(h ? Je(this.ticks, r) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), n.display && (n.autoSkip || n.source === "auto") && (this.ticks = Eo(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), h && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, i;
    this.isHorizontal() ? (e = this.left, i = this.right) : (e = this.top, i = this.bottom, t = !t), this._startPixel = e, this._endPixel = i, this._reversePixels = t, this._length = i - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    T(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    T(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    T(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), T(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    T(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let i, s, a;
    for (i = 0, s = t.length; i < s; i++)
      a = t[i], a.label = T(e.callback, [
        a.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    T(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    T(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, i = Ge(this.ticks.length, t.ticks.maxTicksLimit), s = e.minRotation || 0, a = e.maxRotation;
    let n = s, r, h, l;
    if (!this._isVisible() || !e.display || s >= a || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const c = this._getLabelSizes(), d = c.widest.width, u = c.highest.height, g = Q(this.chart.width - d, 0, this.maxWidth);
    r = t.offset ? this.maxWidth / i : g / (i - 1), d + 6 > r && (r = g / (i - (t.offset ? 0.5 : 1)), h = this.maxHeight - vt(t.grid) - e.padding - Ze(t.title, this.chart.options.font), l = Math.sqrt(d * d + u * u), n = fs(Math.min(Math.asin(Q((c.highest.height + 6) / r, -1, 1)), Math.asin(Q(h / l, -1, 1)) - Math.asin(Q(u / l, -1, 1)))), n = Math.max(s, Math.min(a, n))), this.labelRotation = n;
  }
  afterCalculateLabelRotation() {
    T(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    T(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: i, title: s, grid: a } } = this, n = this._isVisible(), r = this.isHorizontal();
    if (n) {
      const h = Ze(s, e.options.font);
      if (r ? (t.width = this.maxWidth, t.height = vt(a) + h) : (t.height = this.maxHeight, t.width = vt(a) + h), i.display && this.ticks.length) {
        const { first: l, last: c, widest: d, highest: u } = this._getLabelSizes(), g = i.padding * 2, f = Z(this.labelRotation), p = Math.cos(f), m = Math.sin(f);
        if (r) {
          const x = i.mirror ? 0 : m * d.width + p * u.height;
          t.height = Math.min(this.maxHeight, t.height + x + g);
        } else {
          const x = i.mirror ? 0 : p * d.width + m * u.height;
          t.width = Math.min(this.maxWidth, t.width + x + g);
        }
        this._calculatePadding(l, c, m, p);
      }
    }
    this._handleMargins(), r ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, i, s) {
    const { ticks: { align: a, padding: n }, position: r } = this.options, h = this.labelRotation !== 0, l = r !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const c = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let u = 0, g = 0;
      h ? l ? (u = s * t.width, g = i * e.height) : (u = i * t.height, g = s * e.width) : a === "start" ? g = e.width : a === "end" ? u = t.width : a !== "inner" && (u = t.width / 2, g = e.width / 2), this.paddingLeft = Math.max((u - c + n) * this.width / (this.width - c), 0), this.paddingRight = Math.max((g - d + n) * this.width / (this.width - d), 0);
    } else {
      let c = e.height / 2, d = t.height / 2;
      a === "start" ? (c = 0, d = t.height) : a === "end" && (c = e.height, d = 0), this.paddingTop = c + n, this.paddingBottom = d + n;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    T(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, i;
    for (e = 0, i = t.length; e < i; e++)
      L(t[e].label) && (t.splice(e, 1), i--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let i = this.ticks;
      e < i.length && (i = Je(i, e)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, i) {
    const { ctx: s, _longestTextCache: a } = this, n = [], r = [], h = Math.floor(e / Ge(e, i));
    let l = 0, c = 0, d, u, g, f, p, m, x, v, y, _, b;
    for (d = 0; d < e; d += h) {
      if (f = t[d].label, p = this._resolveTickFontOptions(d), s.font = m = p.string, x = a[m] = a[m] || {
        data: {},
        gc: []
      }, v = p.lineHeight, y = _ = 0, !L(f) && !V(f))
        y = Ce(s, x.data, x.gc, y, f), _ = v;
      else if (V(f))
        for (u = 0, g = f.length; u < g; ++u)
          b = f[u], !L(b) && !V(b) && (y = Ce(s, x.data, x.gc, y, b), _ += v);
      n.push(y), r.push(_), l = Math.max(y, l), c = Math.max(_, c);
    }
    Wo(a, e);
    const M = n.indexOf(l), k = r.indexOf(c), w = (O) => ({
      width: n[O] || 0,
      height: r[O] || 0
    });
    return {
      first: w(0),
      last: w(e - 1),
      widest: w(M),
      highest: w(k),
      widths: n,
      heights: r
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return ps(this._alignToPixels ? ot(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const i = e[t];
      return i.$context || (i.$context = jo(this.getContext(), t, i));
    }
    return this.$context || (this.$context = No(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = Z(this.labelRotation), i = Math.abs(Math.cos(e)), s = Math.abs(Math.sin(e)), a = this._getLabelSizes(), n = t.autoSkipPadding || 0, r = a ? a.widest.width + n : 0, h = a ? a.highest.height + n : 0;
    return this.isHorizontal() ? h * i > r * s ? r / i : h / s : h * s < r * i ? h / i : r / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, i = this.chart, s = this.options, { grid: a, position: n, border: r } = s, h = a.offset, l = this.isHorizontal(), c = this.ticks.length + (h ? 1 : 0), d = vt(a), u = [], g = r.setContext(this.getContext()), f = g.display ? g.width : 0, p = f / 2, m = function(A) {
      return ot(i, A, f);
    };
    let x, v, y, _, b, M, k, w, O, S, D, I;
    if (n === "top")
      x = m(this.bottom), M = this.bottom - d, w = x - p, S = m(t.top) + p, I = t.bottom;
    else if (n === "bottom")
      x = m(this.top), S = t.top, I = m(t.bottom) - p, M = x + p, w = this.top + d;
    else if (n === "left")
      x = m(this.right), b = this.right - d, k = x - p, O = m(t.left) + p, D = t.right;
    else if (n === "right")
      x = m(this.left), O = t.left, D = m(t.right) - p, b = x + p, k = this.left + d;
    else if (e === "x") {
      if (n === "center")
        x = m((t.top + t.bottom) / 2 + 0.5);
      else if (E(n)) {
        const A = Object.keys(n)[0], R = n[A];
        x = m(this.chart.scales[A].getPixelForValue(R));
      }
      S = t.top, I = t.bottom, M = x + p, w = M + d;
    } else if (e === "y") {
      if (n === "center")
        x = m((t.left + t.right) / 2);
      else if (E(n)) {
        const A = Object.keys(n)[0], R = n[A];
        x = m(this.chart.scales[A].getPixelForValue(R));
      }
      b = x - p, k = b - d, O = t.left, D = t.right;
    }
    const j = P(s.ticks.maxTicksLimit, c), U = Math.max(1, Math.ceil(c / j));
    for (v = 0; v < c; v += U) {
      const A = this.getContext(v), R = a.setContext(A), Ct = r.setContext(A), It = R.lineWidth, Jt = R.color, rt = Ct.dash || [], Tt = Ct.dashOffset, ht = R.tickWidth, pt = R.tickColor, st = R.tickBorderDash || [], xt = R.tickBorderDashOffset;
      y = Ho(this, v, h), y !== void 0 && (_ = ot(i, y, It), l ? b = k = O = D = _ : M = w = S = I = _, u.push({
        tx1: b,
        ty1: M,
        tx2: k,
        ty2: w,
        x1: O,
        y1: S,
        x2: D,
        y2: I,
        width: It,
        color: Jt,
        borderDash: rt,
        borderDashOffset: Tt,
        tickWidth: ht,
        tickColor: pt,
        tickBorderDash: st,
        tickBorderDashOffset: xt
      }));
    }
    return this._ticksLength = c, this._borderValue = x, u;
  }
  _computeLabelItems(t) {
    const e = this.axis, i = this.options, { position: s, ticks: a } = i, n = this.isHorizontal(), r = this.ticks, { align: h, crossAlign: l, padding: c, mirror: d } = a, u = vt(i.grid), g = u + c, f = d ? -c : g, p = -Z(this.labelRotation), m = [];
    let x, v, y, _, b, M, k, w, O, S, D, I, j = "middle";
    if (s === "top")
      M = this.bottom - f, k = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      M = this.top + f, k = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const A = this._getYAxisLabelAlignment(u);
      k = A.textAlign, b = A.x;
    } else if (s === "right") {
      const A = this._getYAxisLabelAlignment(u);
      k = A.textAlign, b = A.x;
    } else if (e === "x") {
      if (s === "center")
        M = (t.top + t.bottom) / 2 + g;
      else if (E(s)) {
        const A = Object.keys(s)[0], R = s[A];
        M = this.chart.scales[A].getPixelForValue(R) + g;
      }
      k = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (s === "center")
        b = (t.left + t.right) / 2 - g;
      else if (E(s)) {
        const A = Object.keys(s)[0], R = s[A];
        b = this.chart.scales[A].getPixelForValue(R);
      }
      k = this._getYAxisLabelAlignment(u).textAlign;
    }
    e === "y" && (h === "start" ? j = "top" : h === "end" && (j = "bottom"));
    const U = this._getLabelSizes();
    for (x = 0, v = r.length; x < v; ++x) {
      y = r[x], _ = y.label;
      const A = a.setContext(this.getContext(x));
      w = this.getPixelForTick(x) + a.labelOffset, O = this._resolveTickFontOptions(x), S = O.lineHeight, D = V(_) ? _.length : 1;
      const R = D / 2, Ct = A.color, It = A.textStrokeColor, Jt = A.textStrokeWidth;
      let rt = k;
      n ? (b = w, k === "inner" && (x === v - 1 ? rt = this.options.reverse ? "left" : "right" : x === 0 ? rt = this.options.reverse ? "right" : "left" : rt = "center"), s === "top" ? l === "near" || p !== 0 ? I = -D * S + S / 2 : l === "center" ? I = -U.highest.height / 2 - R * S + S : I = -U.highest.height + S / 2 : l === "near" || p !== 0 ? I = S / 2 : l === "center" ? I = U.highest.height / 2 - R * S : I = U.highest.height - D * S, d && (I *= -1), p !== 0 && !A.showLabelBackdrop && (b += S / 2 * Math.sin(p))) : (M = w, I = (1 - D) * S / 2);
      let Tt;
      if (A.showLabelBackdrop) {
        const ht = W(A.backdropPadding), pt = U.heights[x], st = U.widths[x];
        let xt = I - ht.top, mt = 0 - ht.left;
        switch (j) {
          case "middle":
            xt -= pt / 2;
            break;
          case "bottom":
            xt -= pt;
            break;
        }
        switch (k) {
          case "center":
            mt -= st / 2;
            break;
          case "right":
            mt -= st;
            break;
          case "inner":
            x === v - 1 ? mt -= st : x > 0 && (mt -= st / 2);
            break;
        }
        Tt = {
          left: mt,
          top: xt,
          width: st + ht.width,
          height: pt + ht.height,
          color: A.backdropColor
        };
      }
      m.push({
        label: _,
        font: O,
        textOffset: I,
        options: {
          rotation: p,
          color: Ct,
          strokeColor: It,
          strokeWidth: Jt,
          textAlign: rt,
          textBaseline: j,
          translation: [
            b,
            M
          ],
          backdrop: Tt
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-Z(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return e.align === "start" ? i = "left" : e.align === "end" ? i = "right" : e.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: i, mirror: s, padding: a } } = this.options, n = this._getLabelSizes(), r = t + a, h = n.widest.width;
    let l, c;
    return e === "left" ? s ? (c = this.right + a, i === "near" ? l = "left" : i === "center" ? (l = "center", c += h / 2) : (l = "right", c += h)) : (c = this.right - r, i === "near" ? l = "right" : i === "center" ? (l = "center", c -= h / 2) : (l = "left", c = this.left)) : e === "right" ? s ? (c = this.left + a, i === "near" ? l = "right" : i === "center" ? (l = "center", c -= h / 2) : (l = "left", c -= h)) : (c = this.left + r, i === "near" ? l = "left" : i === "center" ? (l = "center", c += h / 2) : (l = "right", c = this.right)) : l = "right", {
      textAlign: l,
      x: c
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: i, top: s, width: a, height: n } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(i, s, a, n), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const i = this.ticks.findIndex((s) => s.value === t);
    return i >= 0 ? e.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, i = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, n;
    const r = (h, l, c) => {
      !c.width || !c.color || (i.save(), i.lineWidth = c.width, i.strokeStyle = c.color, i.setLineDash(c.borderDash || []), i.lineDashOffset = c.borderDashOffset, i.beginPath(), i.moveTo(h.x, h.y), i.lineTo(l.x, l.y), i.stroke(), i.restore());
    };
    if (e.display)
      for (a = 0, n = s.length; a < n; ++a) {
        const h = s[a];
        e.drawOnChartArea && r({
          x: h.x1,
          y: h.y1
        }, {
          x: h.x2,
          y: h.y2
        }, h), e.drawTicks && r({
          x: h.tx1,
          y: h.ty1
        }, {
          x: h.tx2,
          y: h.ty2
        }, {
          color: h.tickColor,
          width: h.tickWidth,
          borderDash: h.tickBorderDash,
          borderDashOffset: h.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: i, grid: s } } = this, a = i.setContext(this.getContext()), n = i.display ? a.width : 0;
    if (!n)
      return;
    const r = s.setContext(this.getContext(0)).lineWidth, h = this._borderValue;
    let l, c, d, u;
    this.isHorizontal() ? (l = ot(t, this.left, n) - n / 2, c = ot(t, this.right, r) + r / 2, d = u = h) : (d = ot(t, this.top, n) - n / 2, u = ot(t, this.bottom, r) + r / 2, l = c = h), e.save(), e.lineWidth = a.width, e.strokeStyle = a.color, e.beginPath(), e.moveTo(l, d), e.lineTo(c, u), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const e = this.ctx, i = this._computeLabelArea();
    i && Yt(e, i);
    const s = this.getLabelItems(t);
    for (const a of s) {
      const n = a.options, r = a.font, h = a.label, l = a.textOffset;
      Dt(e, h, 0, l, r, n);
    }
    i && Xt(e);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: i, reverse: s } } = this;
    if (!i.display)
      return;
    const a = F(i.font), n = W(i.padding), r = i.align;
    let h = a.lineHeight / 2;
    e === "bottom" || e === "center" || E(e) ? (h += n.bottom, V(i.text) && (h += a.lineHeight * (i.text.length - 1))) : h += n.top;
    const { titleX: l, titleY: c, maxWidth: d, rotation: u } = Yo(this, h, e, r);
    Dt(t, i.text, 0, 0, a, {
      color: i.color,
      maxWidth: d,
      rotation: u,
      textAlign: Uo(r, e, s),
      textBaseline: "middle",
      translation: [
        l,
        c
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, i = P(t.grid && t.grid.z, -1), s = P(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== At.prototype.draw ? [
      {
        z: e,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: i,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", s = [];
    let a, n;
    for (a = 0, n = e.length; a < n; ++a) {
      const r = e[a];
      r[i] === this.id && (!t || r.type === t) && s.push(r);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return F(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class zt {
  constructor(t, e, i) {
    this.type = t, this.scope = e, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let i;
    Ko(e) && (i = this.register(e));
    const s = this.items, a = t.id, n = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in s || (s[a] = t, Xo(t, n, i), this.override && z.override(t.id, t.overrides)), n;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, i = t.id, s = this.scope;
    i in e && delete e[i], s && i in z[s] && (delete z[s][i], this.override && delete gt[i]);
  }
}
function Xo(o, t, e) {
  const i = Ps(/* @__PURE__ */ Object.create(null), [
    e ? z.get(e) : {},
    z.get(t),
    o.defaults
  ]);
  z.set(t, i), o.defaultRoutes && qo(t, o.defaultRoutes), o.descriptors && z.describe(t, o.descriptors);
}
function qo(o, t) {
  Object.keys(t).forEach((e) => {
    const i = e.split("."), s = i.pop(), a = [
      o
    ].concat(i).join("."), n = t[e].split("."), r = n.pop(), h = n.join(".");
    z.route(a, s, h, r);
  });
}
function Ko(o) {
  return "id" in o && "defaults" in o;
}
class Go {
  constructor() {
    this.controllers = new zt(qt, "datasets", !0), this.elements = new zt(it, "elements"), this.plugins = new zt(Object, "plugins"), this.scales = new zt(At, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, i) {
    [
      ...e
    ].forEach((s) => {
      const a = i || this._getRegistryForType(s);
      i || a.isForType(s) || a === this.plugins && s.id ? this._exec(t, a, s) : C(s, (n) => {
        const r = i || this._getRegistryForType(n);
        this._exec(t, r, n);
      });
    });
  }
  _exec(t, e, i) {
    const s = us(t);
    T(i["before" + s], [], i), e[t](i), T(i["after" + s], [], i);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const i = this._typedRegistries[e];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, e, i) {
    const s = e.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return s;
  }
}
var q = /* @__PURE__ */ new Go();
class Jo {
  constructor() {
    this._init = [];
  }
  notify(t, e, i, s) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = s ? this._descriptors(t).filter(s) : this._descriptors(t), n = this._notify(a, t, e, i);
    return e === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), n;
  }
  _notify(t, e, i, s) {
    s = s || {};
    for (const a of t) {
      const n = a.plugin, r = n[i], h = [
        e,
        s,
        a.options
      ];
      if (T(r, h, n) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    L(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const i = t && t.config, s = P(i.options && i.options.plugins, {}), a = Zo(i);
    return s === !1 && !e ? [] : ta(t, a, s, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], i = this._cache, s = (a, n) => a.filter((r) => !n.some((h) => r.plugin.id === h.plugin.id));
    this._notify(s(e, i), t, "stop"), this._notify(s(i, e), t, "start");
  }
}
function Zo(o) {
  const t = {}, e = [], i = Object.keys(q.plugins.items);
  for (let a = 0; a < i.length; a++)
    e.push(q.getPlugin(i[a]));
  const s = o.plugins || [];
  for (let a = 0; a < s.length; a++) {
    const n = s[a];
    e.indexOf(n) === -1 && (e.push(n), t[n.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function Qo(o, t) {
  return !t && o === !1 ? null : o === !0 ? {} : o;
}
function ta(o, { plugins: t, localIds: e }, i, s) {
  const a = [], n = o.getContext();
  for (const r of t) {
    const h = r.id, l = Qo(i[h], s);
    l !== null && a.push({
      plugin: r,
      options: ea(o.config, {
        plugin: r,
        local: e[h]
      }, l, n)
    });
  }
  return a;
}
function ea(o, { plugin: t, local: e }, i, s) {
  const a = o.pluginScopeKeys(t), n = o.getOptionScopes(i, a);
  return e && t.defaults && n.push(t.defaults), o.createResolver(n, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function fe(o, t) {
  const e = z.datasets[o] || {};
  return ((t.datasets || {})[o] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function ia(o, t) {
  let e = o;
  return o === "_index_" ? e = t : o === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function sa(o, t) {
  return o === t ? "_index_" : "_value_";
}
function Qe(o) {
  if (o === "x" || o === "y" || o === "r")
    return o;
}
function oa(o) {
  if (o === "top" || o === "bottom")
    return "x";
  if (o === "left" || o === "right")
    return "y";
}
function pe(o, ...t) {
  if (Qe(o))
    return o;
  for (const e of t) {
    const i = e.axis || oa(e.position) || o.length > 1 && Qe(o[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${o}' axis. Please provide 'axis' or 'position' option.`);
}
function ti(o, t, e) {
  if (e[t + "AxisID"] === o)
    return {
      axis: t
    };
}
function aa(o, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((i) => i.xAxisID === o || i.yAxisID === o);
    if (e.length)
      return ti(o, "x", e[0]) || ti(o, "y", e[0]);
  }
  return {};
}
function na(o, t) {
  const e = gt[o.type] || {
    scales: {}
  }, i = t.scales || {}, s = fe(o.type, t), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((n) => {
    const r = i[n];
    if (!E(r))
      return console.error(`Invalid scale configuration for scale: ${n}`);
    if (r._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${n}`);
    const h = pe(n, r, aa(n, o), z.scales[r.type]), l = sa(h, s), c = e.scales || {};
    a[n] = Qt(/* @__PURE__ */ Object.create(null), [
      {
        axis: h
      },
      r,
      c[h],
      c[l]
    ]);
  }), o.data.datasets.forEach((n) => {
    const r = n.type || o.type, h = n.indexAxis || fe(r, t), l = (gt[r] || {}).scales || {};
    Object.keys(l).forEach((c) => {
      const d = ia(c, h), u = n[d + "AxisID"] || d;
      a[u] = a[u] || /* @__PURE__ */ Object.create(null), Qt(a[u], [
        {
          axis: d
        },
        i[u],
        l[c]
      ]);
    });
  }), Object.keys(a).forEach((n) => {
    const r = a[n];
    Qt(r, [
      z.scales[r.type],
      z.scale
    ]);
  }), a;
}
function Vi(o) {
  const t = o.options || (o.options = {});
  t.plugins = P(t.plugins, {}), t.scales = na(o, t);
}
function Hi(o) {
  return o = o || {}, o.datasets = o.datasets || [], o.labels = o.labels || [], o;
}
function ra(o) {
  return o = o || {}, o.data = Hi(o.data), Vi(o), o;
}
const ei = /* @__PURE__ */ new Map(), Wi = /* @__PURE__ */ new Set();
function Rt(o, t) {
  let e = ei.get(o);
  return e || (e = t(), ei.set(o, e), Wi.add(e)), e;
}
const wt = (o, t, e) => {
  const i = ut(t, e);
  i !== void 0 && o.add(i);
};
class ha {
  constructor(t) {
    this._config = ra(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Hi(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Vi(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Rt(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return Rt(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return Rt(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, i = this.type;
    return Rt(`${i}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const i = this._scopeCache;
    let s = i.get(t);
    return (!s || e) && (s = /* @__PURE__ */ new Map(), i.set(t, s)), s;
  }
  getOptionScopes(t, e, i) {
    const { options: s, type: a } = this, n = this._cachedScopes(t, i), r = n.get(e);
    if (r)
      return r;
    const h = /* @__PURE__ */ new Set();
    e.forEach((c) => {
      t && (h.add(t), c.forEach((d) => wt(h, t, d))), c.forEach((d) => wt(h, s, d)), c.forEach((d) => wt(h, gt[a] || {}, d)), c.forEach((d) => wt(h, z, d)), c.forEach((d) => wt(h, Pe, d));
    });
    const l = Array.from(h);
    return l.length === 0 && l.push(/* @__PURE__ */ Object.create(null)), Wi.has(e) && n.set(e, l), l;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      gt[e] || {},
      z.datasets[e] || {},
      {
        type: e
      },
      z,
      Pe
    ];
  }
  resolveNamedOptions(t, e, i, s = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: n, subPrefixes: r } = ii(this._resolverCache, t, s);
    let h = n;
    if (ca(n, e)) {
      a.$shared = !1, i = Ut(i) ? i() : i;
      const l = this.createResolver(t, i, r);
      h = Ae(n, i, l);
    }
    for (const l of e)
      a[l] = h[l];
    return a;
  }
  createResolver(t, e, i = [
    ""
  ], s) {
    const { resolver: a } = ii(this._resolverCache, t, i);
    return E(e) ? Ae(a, e, void 0, s) : a;
  }
}
function ii(o, t, e) {
  let i = o.get(t);
  i || (i = /* @__PURE__ */ new Map(), o.set(t, i));
  const s = e.join();
  let a = i.get(s);
  return a || (a = {
    resolver: vs(t, e),
    subPrefixes: e.filter((n) => !n.toLowerCase().includes("hover"))
  }, i.set(s, a)), a;
}
const la = (o) => E(o) && Object.getOwnPropertyNames(o).some((t) => Ut(o[t]));
function ca(o, t) {
  const { isScriptable: e, isIndexable: i } = ws(o);
  for (const s of t) {
    const a = e(s), n = i(s), r = (n || a) && o[s];
    if (a && (Ut(r) || la(r)) || n && V(r))
      return !0;
  }
  return !1;
}
var da = "4.5.0";
const ua = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function si(o, t) {
  return o === "top" || o === "bottom" || ua.indexOf(o) === -1 && t === "x";
}
function oi(o, t) {
  return function(e, i) {
    return e[o] === i[o] ? e[t] - i[t] : e[o] - i[o];
  };
}
function ai(o) {
  const t = o.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), T(e && e.onComplete, [
    o
  ], t);
}
function ga(o) {
  const t = o.chart, e = t.options.animation;
  T(e && e.onProgress, [
    o
  ], t);
}
function Ni(o) {
  return Ci() && typeof o == "string" ? o = document.getElementById(o) : o && o.length && (o = o[0]), o && o.canvas && (o = o.canvas), o;
}
const Bt = {}, ni = (o) => {
  const t = Ni(o);
  return Object.values(Bt).filter((e) => e.canvas === t).pop();
};
function fa(o, t, e) {
  const i = Object.keys(o);
  for (const s of i) {
    const a = +s;
    if (a >= t) {
      const n = o[s];
      delete o[s], (e > 0 || a > t) && (o[a + e] = n);
    }
  }
}
function pa(o, t, e, i) {
  return !e || o.type === "mouseout" ? null : i ? t : o;
}
class xa {
  static defaults = z;
  static instances = Bt;
  static overrides = gt;
  static registry = q;
  static version = da;
  static getChart = ni;
  static register(...t) {
    q.add(...t), ri();
  }
  static unregister(...t) {
    q.remove(...t), ri();
  }
  constructor(t, e) {
    const i = this.config = new ha(e), s = Ni(t), a = ni(s);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const n = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || Lo(s))(), this.platform.updateConfig(i);
    const r = this.platform.acquireContext(s, n.aspectRatio), h = r && r.canvas, l = h && h.height, c = h && h.width;
    if (this.id = is(), this.ctx = r, this.canvas = h, this.width = c, this.height = l, this._options = n, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Jo(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = ss((d) => this.update(d), n.resizeDelay || 0), this._dataChanges = [], Bt[this.id] = this, !r || !h) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    G.listen(this, "complete", ai), G.listen(this, "progress", ga), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: i, height: s, _aspectRatio: a } = this;
    return L(t) ? e && a ? a : s ? i / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return q;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : ke(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Se(this.canvas, this.ctx), this;
  }
  stop() {
    return G.stop(this), this;
  }
  resize(t, e) {
    G.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const i = this.options, s = this.canvas, a = i.maintainAspectRatio && this.aspectRatio, n = this.platform.getMaximumSize(s, t, e, a), r = i.devicePixelRatio || this.platform.getDevicePixelRatio(), h = this.width ? "resize" : "attach";
    this.width = n.width, this.height = n.height, this._aspectRatio = this.aspectRatio, ke(this, r, !0) && (this.notifyPlugins("resize", {
      size: n
    }), T(i.onResize, [
      this,
      n
    ], this), this.attached && this._doResize(h) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    C(t, (e, i) => {
      e.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, i = this.scales, s = Object.keys(i).reduce((n, r) => (n[r] = !1, n), {});
    let a = [];
    e && (a = a.concat(Object.keys(e).map((n) => {
      const r = e[n], h = pe(n, r), l = h === "r", c = h === "x";
      return {
        options: r,
        dposition: l ? "chartArea" : c ? "bottom" : "left",
        dtype: l ? "radialLinear" : c ? "category" : "linear"
      };
    }))), C(a, (n) => {
      const r = n.options, h = r.id, l = pe(h, r), c = P(r.type, n.dtype);
      (r.position === void 0 || si(r.position, l) !== si(n.dposition)) && (r.position = n.dposition), s[h] = !0;
      let d = null;
      if (h in i && i[h].type === c)
        d = i[h];
      else {
        const u = q.getScale(c);
        d = new u({
          id: h,
          type: c,
          ctx: this.ctx,
          chart: this
        }), i[d.id] = d;
      }
      d.init(r, t);
    }), C(s, (n, r) => {
      n || delete i[r];
    }), C(i, (n) => {
      H.configure(this, n, n.options), H.addBox(this, n);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, i = t.length;
    if (t.sort((s, a) => s.index - a.index), i > e) {
      for (let s = e; s < i; ++s)
        this._destroyDatasetMeta(s);
      t.splice(e, i - e);
    }
    this._sortedMetasets = t.slice(0).sort(oi("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((i, s) => {
      e.filter((a) => a === i._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let i, s;
    for (this._removeUnreferencedMetasets(), i = 0, s = e.length; i < s; i++) {
      const a = e[i];
      let n = this.getDatasetMeta(i);
      const r = a.type || this.config.type;
      if (n.type && n.type !== r && (this._destroyDatasetMeta(i), n = this.getDatasetMeta(i)), n.type = r, n.indexAxis = a.indexAxis || fe(r, this.options), n.order = a.order || 0, n.index = i, n.label = "" + a.label, n.visible = this.isDatasetVisible(i), n.controller)
        n.controller.updateIndex(i), n.controller.linkScales();
      else {
        const h = q.getController(r), { datasetElementType: l, dataElementType: c } = z.datasets[r];
        Object.assign(h, {
          dataElementType: q.getElement(c),
          datasetElementType: l && q.getElement(l)
        }), n.controller = new h(this, i), t.push(n.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    C(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const i = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let n = 0;
    for (let l = 0, c = this.data.datasets.length; l < c; l++) {
      const { controller: d } = this.getDatasetMeta(l), u = !s && a.indexOf(d) === -1;
      d.buildOrUpdateElements(u), n = Math.max(+d.getMaxOverflow(), n);
    }
    n = this._minPadding = i.layout.autoPadding ? n : 0, this._updateLayout(n), s || C(a, (l) => {
      l.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(oi("z", "_idx"));
    const { _active: r, _lastEvent: h } = this;
    h ? this._eventHandler(h, !0) : r.length && this._updateHoverStyles(r, r, !0), this.render();
  }
  _updateScales() {
    C(this.scales, (t) => {
      H.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!De(e, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: i, start: s, count: a } of e) {
      const n = i === "_removeElements" ? -a : a;
      fa(t, s, n);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, i = (a) => new Set(t.filter((n) => n[0] === a).map((n, r) => r + "," + n.splice(1).join(","))), s = i(0);
    for (let a = 1; a < e; a++)
      if (!De(s, i(a)))
        return;
    return Array.from(s).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    H.update(this, this.width, this.height, t);
    const e = this.chartArea, i = e.width <= 0 || e.height <= 0;
    this._layers = [], C(this.boxes, (s) => {
      i && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, a) => {
      s._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this._updateDataset(e, Ut(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const i = this.getDatasetMeta(t), s = {
      meta: i,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (i.controller._update(e), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (G.has(this) ? this.attached && !G.running(this) && G.start(this) : (this.draw(), ai({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: s } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(i, s);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, i = [];
    let s, a;
    for (s = 0, a = e.length; s < a; ++s) {
      const n = e[s];
      (!t || n.visible) && i.push(n);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, i = {
      meta: t,
      index: t.index,
      cancelable: !0
    }, s = Si(this, t);
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (s && Yt(e, s), t.controller.draw(), s && Xt(e), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return _e(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, i, s) {
    const a = uo.modes[e];
    return typeof a == "function" ? a(this, t, i, s) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], i = this._metasets;
    let s = i.filter((a) => a && a._dataset === e).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, i.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = ft(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const i = this.getDatasetMeta(t);
    i.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, i) {
    const s = i ? "show" : "hide", a = this.getDatasetMeta(t), n = a.controller._resolveAnimations(void 0, s);
    St(e) ? (a.data[e].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), n.update(a, {
      visible: i
    }), this.update((r) => r.datasetIndex === t ? s : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), G.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Se(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete Bt[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, i = (a, n) => {
      e.addEventListener(this, a, n), t[a] = n;
    }, s = (a, n, r) => {
      a.offsetX = n, a.offsetY = r, this._eventHandler(a);
    };
    C(this.options.events, (a) => i(a, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, i = (h, l) => {
      e.addEventListener(this, h, l), t[h] = l;
    }, s = (h, l) => {
      t[h] && (e.removeEventListener(this, h, l), delete t[h]);
    }, a = (h, l) => {
      this.canvas && this.resize(h, l);
    };
    let n;
    const r = () => {
      s("attach", r), this.attached = !0, this.resize(), i("resize", a), i("detach", n);
    };
    n = () => {
      this.attached = !1, s("resize", a), this._stop(), this._resize(0, 0), i("attach", r);
    }, e.isAttached(this.canvas) ? r() : n();
  }
  unbindEvents() {
    C(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, C(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, i) {
    const s = i ? "set" : "remove";
    let a, n, r, h;
    for (e === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + s + "DatasetHoverStyle"]()), r = 0, h = t.length; r < h; ++r) {
      n = t[r];
      const l = n && this.getDatasetMeta(n.datasetIndex).controller;
      l && l[s + "HoverStyle"](n.element, n.datasetIndex, n.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], i = t.map(({ datasetIndex: s, index: a }) => {
      const n = this.getDatasetMeta(s);
      if (!n)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: n.data[a],
        index: a
      };
    });
    !Vt(i, e) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, e));
  }
  notifyPlugins(t, e, i) {
    return this._plugins.notify(this, t, e, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, i) {
    const s = this.options.hover, a = (h, l) => h.filter((c) => !l.some((d) => c.datasetIndex === d.datasetIndex && c.index === d.index)), n = a(e, t), r = i ? t : a(t, e);
    n.length && this.updateHoverStyle(n, s.mode, !1), r.length && s.mode && this.updateHoverStyle(r, s.mode, !0);
  }
  _eventHandler(t, e) {
    const i = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (n) => (n.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, s) === !1)
      return;
    const a = this._handleEvent(t, e, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, s), (a || i.changed) && this.render(), this;
  }
  _handleEvent(t, e, i) {
    const { _active: s = [], options: a } = this, n = e, r = this._getActiveElements(t, s, i, n), h = os(t), l = pa(t, this._lastEvent, i, h);
    i && (this._lastEvent = null, T(a.onHover, [
      t,
      r,
      this
    ], this), h && T(a.onClick, [
      t,
      r,
      this
    ], this));
    const c = !Vt(r, s);
    return (c || e) && (this._active = r, this._updateHoverStyles(r, s, e)), this._lastEvent = l, c;
  }
  _getActiveElements(t, e, i, s) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return e;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, s);
  }
}
function ri() {
  return C(xa.instances, (o) => o._plugins.invalidate());
}
function ji(o, t, e = t) {
  o.lineCap = P(e.borderCapStyle, t.borderCapStyle), o.setLineDash(P(e.borderDash, t.borderDash)), o.lineDashOffset = P(e.borderDashOffset, t.borderDashOffset), o.lineJoin = P(e.borderJoinStyle, t.borderJoinStyle), o.lineWidth = P(e.borderWidth, t.borderWidth), o.strokeStyle = P(e.borderColor, t.borderColor);
}
function ma(o, t, e) {
  o.lineTo(e.x, e.y);
}
function _a(o) {
  return o.stepped ? Cs : o.tension || o.cubicInterpolationMode === "monotone" ? Is : ma;
}
function Ui(o, t, e = {}) {
  const i = o.length, { start: s = 0, end: a = i - 1 } = e, { start: n, end: r } = t, h = Math.max(s, n), l = Math.min(a, r), c = s < n && a < n || s > r && a > r;
  return {
    count: i,
    start: h,
    loop: t.loop,
    ilen: l < h && !c ? i + l - h : l - h
  };
}
function ba(o, t, e, i) {
  const { points: s, options: a } = t, { count: n, start: r, loop: h, ilen: l } = Ui(s, e, i), c = _a(a);
  let { move: d = !0, reverse: u } = i || {}, g, f, p;
  for (g = 0; g <= l; ++g)
    f = s[(r + (u ? l - g : g)) % n], !f.skip && (d ? (o.moveTo(f.x, f.y), d = !1) : c(o, p, f, u, a.stepped), p = f);
  return h && (f = s[(r + (u ? l : 0)) % n], c(o, p, f, u, a.stepped)), !!h;
}
function ya(o, t, e, i) {
  const s = t.points, { count: a, start: n, ilen: r } = Ui(s, e, i), { move: h = !0, reverse: l } = i || {};
  let c = 0, d = 0, u, g, f, p, m, x;
  const v = (_) => (n + (l ? r - _ : _)) % a, y = () => {
    p !== m && (o.lineTo(c, m), o.lineTo(c, p), o.lineTo(c, x));
  };
  for (h && (g = s[v(0)], o.moveTo(g.x, g.y)), u = 0; u <= r; ++u) {
    if (g = s[v(u)], g.skip)
      continue;
    const _ = g.x, b = g.y, M = _ | 0;
    M === f ? (b < p ? p = b : b > m && (m = b), c = (d * c + _) / ++d) : (y(), o.lineTo(_, b), f = M, d = 0, p = m = b), x = b;
  }
  y();
}
function xe(o) {
  const t = o.options, e = t.borderDash && t.borderDash.length;
  return !o._decimated && !o._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? ya : ba;
}
function va(o) {
  return o.stepped ? ms : o.tension || o.cubicInterpolationMode === "monotone" ? _s : bs;
}
function wa(o, t, e, i) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, e, i) && s.closePath()), ji(o, t.options), o.stroke(s);
}
function Ma(o, t, e, i) {
  const { segments: s, options: a } = t, n = xe(t);
  for (const r of s)
    ji(o, a, r.style), o.beginPath(), n(o, t, r, {
      start: e,
      end: e + i - 1
    }) && o.closePath(), o.stroke();
}
const ka = typeof Path2D == "function";
function Sa(o, t, e, i) {
  ka && !t.options.segment ? wa(o, t, e, i) : Ma(o, t, e, i);
}
class ye extends it {
  static id = "line";
  static defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: !0,
    cubicInterpolationMode: "default",
    fill: !1,
    spanGaps: !1,
    stepped: !1,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  static descriptors = {
    _scriptable: !0,
    _indexable: (t) => t !== "borderDash" && t !== "fill"
  };
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const s = i.spanGaps ? this._loop : this._fullLoop;
      hs(this._points, i, t, s, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = ls(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, i = t.length;
    return i && e[t[i - 1].end];
  }
  interpolate(t, e) {
    const i = this.options, s = t[e], a = this.points, n = Di(this, {
      property: e,
      start: s,
      end: s
    });
    if (!n.length)
      return;
    const r = [], h = va(i);
    let l, c;
    for (l = 0, c = n.length; l < c; ++l) {
      const { start: d, end: u } = n[l], g = a[d], f = a[u];
      if (g === f) {
        r.push(g);
        continue;
      }
      const p = Math.abs((s - g[e]) / (f[e] - g[e])), m = h(g, f, p, i.stepped);
      m[e] = t[e], r.push(m);
    }
    return r.length === 1 ? r[0] : r;
  }
  pathSegment(t, e, i) {
    return xe(this)(t, this, e, i);
  }
  path(t, e, i) {
    const s = this.segments, a = xe(this);
    let n = this._loop;
    e = e || 0, i = i || this.points.length - e;
    for (const r of s)
      n &= a(t, this, r, {
        start: e,
        end: e + i - 1
      });
    return !!n;
  }
  draw(t, e, i, s) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), Sa(t, this, i, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
function hi(o, t, e, i) {
  const s = o.options, { [e]: a } = o.getProps([
    e
  ], i);
  return Math.abs(t - a) < s.radius + s.hitRadius;
}
class bn extends it {
  static id = "point";
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, e, i) {
    const s = this.options, { x: a, y: n } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(t - a, 2) + Math.pow(e - n, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(t, e) {
    return hi(this, t, "x", e);
  }
  inYRange(t, e) {
    return hi(this, t, "y", e);
  }
  getCenterPoint(t) {
    const { x: e, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: i
    };
  }
  size(t) {
    t = t || this.options || {};
    let e = t.radius || 0;
    e = Math.max(e, e && t.hoverRadius || 0);
    const i = e && t.borderWidth || 0;
    return (e + i) * 2;
  }
  draw(t, e) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !_e(this, e, this.size(i) / 2) || (t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.fillStyle = i.backgroundColor, ue(t, i, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
function Yi(o, t) {
  const { x: e, y: i, base: s, width: a, height: n } = o.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let r, h, l, c, d;
  return o.horizontal ? (d = n / 2, r = Math.min(e, s), h = Math.max(e, s), l = i - d, c = i + d) : (d = a / 2, r = e - d, h = e + d, l = Math.min(i, s), c = Math.max(i, s)), {
    left: r,
    top: l,
    right: h,
    bottom: c
  };
}
function tt(o, t, e, i) {
  return o ? 0 : Q(t, e, i);
}
function Da(o, t, e) {
  const i = o.options.borderWidth, s = o.borderSkipped, a = Ds(i);
  return {
    t: tt(s.top, a.top, 0, e),
    r: tt(s.right, a.right, 0, t),
    b: tt(s.bottom, a.bottom, 0, e),
    l: tt(s.left, a.left, 0, t)
  };
}
function Pa(o, t, e) {
  const { enableBorderRadius: i } = o.getProps([
    "enableBorderRadius"
  ]), s = o.options.borderRadius, a = ct(s), n = Math.min(t, e), r = o.borderSkipped, h = i || E(s);
  return {
    topLeft: tt(!h || r.top || r.left, a.topLeft, 0, n),
    topRight: tt(!h || r.top || r.right, a.topRight, 0, n),
    bottomLeft: tt(!h || r.bottom || r.left, a.bottomLeft, 0, n),
    bottomRight: tt(!h || r.bottom || r.right, a.bottomRight, 0, n)
  };
}
function Aa(o) {
  const t = Yi(o), e = t.right - t.left, i = t.bottom - t.top, s = Da(o, e / 2, i / 2), a = Pa(o, e / 2, i / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: i,
      radius: a
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: e - s.l - s.r,
      h: i - s.t - s.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, a.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function re(o, t, e, i) {
  const s = t === null, a = e === null, n = o && !(s && a) && Yi(o, i);
  return n && (s || nt(t, n.left, n.right)) && (a || nt(e, n.top, n.bottom));
}
function Ca(o) {
  return o.topLeft || o.topRight || o.bottomLeft || o.bottomRight;
}
function Ia(o, t) {
  o.rect(t.x, t.y, t.w, t.h);
}
function he(o, t, e = {}) {
  const i = o.x !== e.x ? -t : 0, s = o.y !== e.y ? -t : 0, a = (o.x + o.w !== e.x + e.w ? t : 0) - i, n = (o.y + o.h !== e.y + e.h ? t : 0) - s;
  return {
    x: o.x + i,
    y: o.y + s,
    w: o.w + a,
    h: o.h + n,
    radius: o.radius
  };
}
class yn extends it {
  static id = "bar";
  static defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: void 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: i, backgroundColor: s } } = this, { inner: a, outer: n } = Aa(this), r = Ca(n.radius) ? Ht : Ia;
    t.save(), (n.w !== a.w || n.h !== a.h) && (t.beginPath(), r(t, he(n, e, a)), t.clip(), r(t, he(a, -e, n)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), r(t, he(a, e)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, e, i) {
    return re(this, t, e, i);
  }
  inXRange(t, e) {
    return re(this, t, null, e);
  }
  inYRange(t, e) {
    return re(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: i, base: s, horizontal: a } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: a ? (e + s) / 2 : e,
      y: a ? i : (i + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
function Ta(o, t, e) {
  const i = o.segments, s = o.points, a = t.points, n = [];
  for (const r of i) {
    let { start: h, end: l } = r;
    l = Gt(h, l, s);
    const c = me(e, s[h], s[l], r.loop);
    if (!t.segments) {
      n.push({
        source: r,
        target: c,
        start: s[h],
        end: s[l]
      });
      continue;
    }
    const d = Di(t, c);
    for (const u of d) {
      const g = me(e, a[u.start], a[u.end], u.loop), f = zs(r, s, g);
      for (const p of f)
        n.push({
          source: p,
          target: u,
          start: {
            [e]: li(c, g, "start", Math.max)
          },
          end: {
            [e]: li(c, g, "end", Math.min)
          }
        });
    }
  }
  return n;
}
function me(o, t, e, i) {
  if (i)
    return;
  let s = t[o], a = e[o];
  return o === "angle" && (s = Le(s), a = Le(a)), {
    property: o,
    start: s,
    end: a
  };
}
function Oa(o, t) {
  const { x: e = null, y: i = null } = o || {}, s = t.points, a = [];
  return t.segments.forEach(({ start: n, end: r }) => {
    r = Gt(n, r, s);
    const h = s[n], l = s[r];
    i !== null ? (a.push({
      x: h.x,
      y: i
    }), a.push({
      x: l.x,
      y: i
    })) : e !== null && (a.push({
      x: e,
      y: h.y
    }), a.push({
      x: e,
      y: l.y
    }));
  }), a;
}
function Gt(o, t, e) {
  for (; t > o; t--) {
    const i = e[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function li(o, t, e, i) {
  return o && t ? i(o[e], t[e]) : o ? o[e] : t ? t[e] : 0;
}
function Xi(o, t) {
  let e = [], i = !1;
  return V(o) ? (i = !0, e = o) : e = Oa(o, t), e.length ? new ye({
    points: e,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function ci(o) {
  return o && o.fill !== !1;
}
function La(o, t, e) {
  let i = o[t].fill;
  const s = [
    t
  ];
  let a;
  if (!e)
    return i;
  for (; i !== !1 && s.indexOf(i) === -1; ) {
    if (!N(i))
      return i;
    if (a = o[i], !a)
      return !1;
    if (a.visible)
      return i;
    s.push(i), i = a.fill;
  }
  return !1;
}
function Ea(o, t, e) {
  const i = Fa(o);
  if (E(i))
    return isNaN(i.value) ? !1 : i;
  let s = parseFloat(i);
  return N(s) && Math.floor(s) === s ? za(i[0], t, s, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function za(o, t, e, i) {
  return (o === "-" || o === "+") && (e = t + e), e === t || e < 0 || e >= i ? !1 : e;
}
function Ra(o, t) {
  let e = null;
  return o === "start" ? e = t.bottom : o === "end" ? e = t.top : E(o) ? e = t.getPixelForValue(o.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function $a(o, t, e) {
  let i;
  return o === "start" ? i = e : o === "end" ? i = t.options.reverse ? t.min : t.max : E(o) ? i = o.value : i = t.getBaseValue(), i;
}
function Fa(o) {
  const t = o.options, e = t.fill;
  let i = P(e && e.target, e);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function Ba(o) {
  const { scale: t, index: e, line: i } = o, s = [], a = i.segments, n = i.points, r = Va(t, e);
  r.push(Xi({
    x: null,
    y: t.bottom
  }, i));
  for (let h = 0; h < a.length; h++) {
    const l = a[h];
    for (let c = l.start; c <= l.end; c++)
      Ha(s, n[c], r);
  }
  return new ye({
    points: s,
    options: {}
  });
}
function Va(o, t) {
  const e = [], i = o.getMatchingVisibleMetas("line");
  for (let s = 0; s < i.length; s++) {
    const a = i[s];
    if (a.index === t)
      break;
    a.hidden || e.unshift(a.dataset);
  }
  return e;
}
function Ha(o, t, e) {
  const i = [];
  for (let s = 0; s < e.length; s++) {
    const a = e[s], { first: n, last: r, point: h } = Wa(a, t, "x");
    if (!(!h || n && r)) {
      if (n)
        i.unshift(h);
      else if (o.push(h), !r)
        break;
    }
  }
  o.push(...i);
}
function Wa(o, t, e) {
  const i = o.interpolate(t, e);
  if (!i)
    return {};
  const s = i[e], a = o.segments, n = o.points;
  let r = !1, h = !1;
  for (let l = 0; l < a.length; l++) {
    const c = a[l], d = n[c.start][e], u = n[c.end][e];
    if (nt(s, d, u)) {
      r = s === d, h = s === u;
      break;
    }
  }
  return {
    first: r,
    last: h,
    point: i
  };
}
class qi {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, i) {
    const { x: s, y: a, radius: n } = this;
    return e = e || {
      start: 0,
      end: lt
    }, t.arc(s, a, n, e.end, e.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: e, y: i, radius: s } = this, a = t.angle;
    return {
      x: e + Math.cos(a) * s,
      y: i + Math.sin(a) * s,
      angle: a
    };
  }
}
function Na(o) {
  const { chart: t, fill: e, line: i } = o;
  if (N(e))
    return ja(t, e);
  if (e === "stack")
    return Ba(o);
  if (e === "shape")
    return !0;
  const s = Ua(o);
  return s instanceof qi ? s : Xi(s, i);
}
function ja(o, t) {
  const e = o.getDatasetMeta(t);
  return e && o.isDatasetVisible(t) ? e.dataset : null;
}
function Ua(o) {
  return (o.scale || {}).getPointPositionForValue ? Xa(o) : Ya(o);
}
function Ya(o) {
  const { scale: t = {}, fill: e } = o, i = Ra(e, t);
  if (N(i)) {
    const s = t.isHorizontal();
    return {
      x: s ? i : null,
      y: s ? null : i
    };
  }
  return null;
}
function Xa(o) {
  const { scale: t, fill: e } = o, i = t.options, s = t.getLabels().length, a = i.reverse ? t.max : t.min, n = $a(e, t, a), r = [];
  if (i.grid.circular) {
    const h = t.getPointPositionForValue(0, a);
    return new qi({
      x: h.x,
      y: h.y,
      radius: t.getDistanceFromCenterForValue(n)
    });
  }
  for (let h = 0; h < s; ++h)
    r.push(t.getPointPositionForValue(h, n));
  return r;
}
function le(o, t, e) {
  const i = Na(t), { chart: s, index: a, line: n, scale: r, axis: h } = t, l = n.options, c = l.fill, d = l.backgroundColor, { above: u = d, below: g = d } = c || {}, f = s.getDatasetMeta(a), p = Si(s, f);
  i && n.points.length && (Yt(o, e), qa(o, {
    line: n,
    target: i,
    above: u,
    below: g,
    area: e,
    scale: r,
    axis: h,
    clip: p
  }), Xt(o));
}
function qa(o, t) {
  const { line: e, target: i, above: s, below: a, area: n, scale: r, clip: h } = t, l = e._loop ? "angle" : t.axis;
  o.save();
  let c = a;
  a !== s && (l === "x" ? (di(o, i, n.top), ce(o, {
    line: e,
    target: i,
    color: s,
    scale: r,
    property: l,
    clip: h
  }), o.restore(), o.save(), di(o, i, n.bottom)) : l === "y" && (ui(o, i, n.left), ce(o, {
    line: e,
    target: i,
    color: a,
    scale: r,
    property: l,
    clip: h
  }), o.restore(), o.save(), ui(o, i, n.right), c = s)), ce(o, {
    line: e,
    target: i,
    color: c,
    scale: r,
    property: l,
    clip: h
  }), o.restore();
}
function di(o, t, e) {
  const { segments: i, points: s } = t;
  let a = !0, n = !1;
  o.beginPath();
  for (const r of i) {
    const { start: h, end: l } = r, c = s[h], d = s[Gt(h, l, s)];
    a ? (o.moveTo(c.x, c.y), a = !1) : (o.lineTo(c.x, e), o.lineTo(c.x, c.y)), n = !!t.pathSegment(o, r, {
      move: n
    }), n ? o.closePath() : o.lineTo(d.x, e);
  }
  o.lineTo(t.first().x, e), o.closePath(), o.clip();
}
function ui(o, t, e) {
  const { segments: i, points: s } = t;
  let a = !0, n = !1;
  o.beginPath();
  for (const r of i) {
    const { start: h, end: l } = r, c = s[h], d = s[Gt(h, l, s)];
    a ? (o.moveTo(c.x, c.y), a = !1) : (o.lineTo(e, c.y), o.lineTo(c.x, c.y)), n = !!t.pathSegment(o, r, {
      move: n
    }), n ? o.closePath() : o.lineTo(e, d.y);
  }
  o.lineTo(e, t.first().y), o.closePath(), o.clip();
}
function ce(o, t) {
  const { line: e, target: i, property: s, color: a, scale: n, clip: r } = t, h = Ta(e, i, s);
  for (const { source: l, target: c, start: d, end: u } of h) {
    const { style: { backgroundColor: g = a } = {} } = l, f = i !== !0;
    o.save(), o.fillStyle = g, Ka(o, n, r, f && me(s, d, u)), o.beginPath();
    const p = !!e.pathSegment(o, l);
    let m;
    if (f) {
      p ? o.closePath() : gi(o, i, u, s);
      const x = !!i.pathSegment(o, c, {
        move: p,
        reverse: !0
      });
      m = p && x, m || gi(o, i, d, s);
    }
    o.closePath(), o.fill(m ? "evenodd" : "nonzero"), o.restore();
  }
}
function Ka(o, t, e, i) {
  const s = t.chart.chartArea, { property: a, start: n, end: r } = i || {};
  if (a === "x" || a === "y") {
    let h, l, c, d;
    a === "x" ? (h = n, l = s.top, c = r, d = s.bottom) : (h = s.left, l = n, c = s.right, d = r), o.beginPath(), e && (h = Math.max(h, e.left), c = Math.min(c, e.right), l = Math.max(l, e.top), d = Math.min(d, e.bottom)), o.rect(h, l, c - h, d - l), o.clip();
  }
}
function gi(o, t, e, i) {
  const s = t.interpolate(e, i);
  s && o.lineTo(s.x, s.y);
}
var vn = {
  id: "filler",
  afterDatasetsUpdate(o, t, e) {
    const i = (o.data.datasets || []).length, s = [];
    let a, n, r, h;
    for (n = 0; n < i; ++n)
      a = o.getDatasetMeta(n), r = a.dataset, h = null, r && r.options && r instanceof ye && (h = {
        visible: o.isDatasetVisible(n),
        index: n,
        fill: Ea(r, n, i),
        chart: o,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: r
      }), a.$filler = h, s.push(h);
    for (n = 0; n < i; ++n)
      h = s[n], !(!h || h.fill === !1) && (h.fill = La(s, n, e.propagate));
  },
  beforeDraw(o, t, e) {
    const i = e.drawTime === "beforeDraw", s = o.getSortedVisibleDatasetMetas(), a = o.chartArea;
    for (let n = s.length - 1; n >= 0; --n) {
      const r = s[n].$filler;
      r && (r.line.updateControlPoints(a, r.axis), i && r.fill && le(o.ctx, r, a));
    }
  },
  beforeDatasetsDraw(o, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const i = o.getSortedVisibleDatasetMetas();
    for (let s = i.length - 1; s >= 0; --s) {
      const a = i[s].$filler;
      ci(a) && le(o.ctx, a, o.chartArea);
    }
  },
  beforeDatasetDraw(o, t, e) {
    const i = t.meta.$filler;
    !ci(i) || e.drawTime !== "beforeDatasetDraw" || le(o.ctx, i, o.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const fi = (o, t) => {
  let { boxHeight: e = t, boxWidth: i = t } = o;
  return o.usePointStyle && (e = Math.min(e, t), i = o.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, Ga = (o, t) => o !== null && t !== null && o.datasetIndex === t.datasetIndex && o.index === t.index;
class pi extends it {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, i) {
    this.maxWidth = t, this.maxHeight = e, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = T(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((i) => t.filter(i, this.chart.data))), t.sort && (e = e.sort((i, s) => t.sort(i, s, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, s = F(i.font), a = s.size, n = this._computeTitleHeight(), { boxWidth: r, itemHeight: h } = fi(i, a);
    let l, c;
    e.font = s.string, this.isHorizontal() ? (l = this.maxWidth, c = this._fitRows(n, a, r, h) + 10) : (c = this.maxHeight, l = this._fitCols(n, s, r, h) + 10), this.width = Math.min(l, t.maxWidth || this.maxWidth), this.height = Math.min(c, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, i, s) {
    const { ctx: a, maxWidth: n, options: { labels: { padding: r } } } = this, h = this.legendHitBoxes = [], l = this.lineWidths = [
      0
    ], c = s + r;
    let d = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let u = -1, g = -c;
    return this.legendItems.forEach((f, p) => {
      const m = i + e / 2 + a.measureText(f.text).width;
      (p === 0 || l[l.length - 1] + m + 2 * r > n) && (d += c, l[l.length - (p > 0 ? 0 : 1)] = 0, g += c, u++), h[p] = {
        left: 0,
        top: g,
        row: u,
        width: m,
        height: s
      }, l[l.length - 1] += m + r;
    }), d;
  }
  _fitCols(t, e, i, s) {
    const { ctx: a, maxHeight: n, options: { labels: { padding: r } } } = this, h = this.legendHitBoxes = [], l = this.columnSizes = [], c = n - t;
    let d = r, u = 0, g = 0, f = 0, p = 0;
    return this.legendItems.forEach((m, x) => {
      const { itemWidth: v, itemHeight: y } = Ja(i, e, a, m, s);
      x > 0 && g + y + 2 * r > c && (d += u + r, l.push({
        width: u,
        height: g
      }), f += u + r, p++, u = g = 0), h[x] = {
        left: f,
        top: g,
        col: p,
        width: v,
        height: y
      }, u = Math.max(u, v), g += y + r;
    }), d += u, l.push({
      width: u,
      height: g
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: i, labels: { padding: s }, rtl: a } } = this, n = dt(a, this.left, this.width);
    if (this.isHorizontal()) {
      let r = 0, h = $(i, this.left + s, this.right - this.lineWidths[r]);
      for (const l of e)
        r !== l.row && (r = l.row, h = $(i, this.left + s, this.right - this.lineWidths[r])), l.top += this.top + t + s, l.left = n.leftForLtr(n.x(h), l.width), h += l.width + s;
    } else {
      let r = 0, h = $(i, this.top + t + s, this.bottom - this.columnSizes[r].height);
      for (const l of e)
        l.col !== r && (r = l.col, h = $(i, this.top + t + s, this.bottom - this.columnSizes[r].height)), l.top = h, l.left += this.left + s, l.left = n.leftForLtr(n.x(l.left), l.width), h += l.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Yt(t, this), this._draw(), Xt(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: i, ctx: s } = this, { align: a, labels: n } = t, r = z.color, h = dt(t.rtl, this.left, this.width), l = F(n.font), { padding: c } = n, d = l.size, u = d / 2;
    let g;
    this.drawTitle(), s.textAlign = h.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = l.string;
    const { boxWidth: f, boxHeight: p, itemHeight: m } = fi(n, d), x = function(M, k, w) {
      if (isNaN(f) || f <= 0 || isNaN(p) || p < 0)
        return;
      s.save();
      const O = P(w.lineWidth, 1);
      if (s.fillStyle = P(w.fillStyle, r), s.lineCap = P(w.lineCap, "butt"), s.lineDashOffset = P(w.lineDashOffset, 0), s.lineJoin = P(w.lineJoin, "miter"), s.lineWidth = O, s.strokeStyle = P(w.strokeStyle, r), s.setLineDash(P(w.lineDash, [])), n.usePointStyle) {
        const S = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: w.pointStyle,
          rotation: w.rotation,
          borderWidth: O
        }, D = h.xPlus(M, f / 2), I = k + u;
        ys(s, S, D, I, n.pointStyleWidth && f);
      } else {
        const S = k + Math.max((d - p) / 2, 0), D = h.leftForLtr(M, f), I = ct(w.borderRadius);
        s.beginPath(), Object.values(I).some((j) => j !== 0) ? Ht(s, {
          x: D,
          y: S,
          w: f,
          h: p,
          radius: I
        }) : s.rect(D, S, f, p), s.fill(), O !== 0 && s.stroke();
      }
      s.restore();
    }, v = function(M, k, w) {
      Dt(s, w.text, M, k + m / 2, l, {
        strikethrough: w.hidden,
        textAlign: h.textAlign(w.textAlign)
      });
    }, y = this.isHorizontal(), _ = this._computeTitleHeight();
    y ? g = {
      x: $(a, this.left + c, this.right - i[0]),
      y: this.top + c + _,
      line: 0
    } : g = {
      x: this.left + c,
      y: $(a, this.top + _ + c, this.bottom - e[0].height),
      line: 0
    }, Pi(this.ctx, t.textDirection);
    const b = m + c;
    this.legendItems.forEach((M, k) => {
      s.strokeStyle = M.fontColor, s.fillStyle = M.fontColor;
      const w = s.measureText(M.text).width, O = h.textAlign(M.textAlign || (M.textAlign = n.textAlign)), S = f + u + w;
      let D = g.x, I = g.y;
      h.setWidth(this.width), y ? k > 0 && D + S + c > this.right && (I = g.y += b, g.line++, D = g.x = $(a, this.left + c, this.right - i[g.line])) : k > 0 && I + b > this.bottom && (D = g.x = D + e[g.line].width + c, g.line++, I = g.y = $(a, this.top + _ + c, this.bottom - e[g.line].height));
      const j = h.x(D);
      if (x(j, I, M), D = ds(O, D + f + u, y ? D + S : this.right, t.rtl), v(h.x(D), I, M), y)
        g.x += S + c;
      else if (typeof M.text != "string") {
        const U = l.lineHeight;
        g.y += Ki(M, U) + c;
      } else
        g.y += b;
    }), Ai(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, i = F(e.font), s = W(e.padding);
    if (!e.display)
      return;
    const a = dt(t.rtl, this.left, this.width), n = this.ctx, r = e.position, h = i.size / 2, l = s.top + h;
    let c, d = this.left, u = this.width;
    if (this.isHorizontal())
      u = Math.max(...this.lineWidths), c = this.top + l, d = $(t.align, d, this.right - u);
    else {
      const f = this.columnSizes.reduce((p, m) => Math.max(p, m.height), 0);
      c = l + $(t.align, this.top, this.bottom - f - t.labels.padding - this._computeTitleHeight());
    }
    const g = $(r, d, d + u);
    n.textAlign = a.textAlign(be(r)), n.textBaseline = "middle", n.strokeStyle = e.color, n.fillStyle = e.color, n.font = i.string, Dt(n, e.text, g, c, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = F(t.font), i = W(t.padding);
    return t.display ? e.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, e) {
    let i, s, a;
    if (nt(t, this.left, this.right) && nt(e, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, i = 0; i < a.length; ++i)
        if (s = a[i], nt(t, s.left, s.left + s.width) && nt(e, s.top, s.top + s.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!tn(t.type, e))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, a = Ga(s, i);
      s && !a && T(e.onLeave, [
        t,
        s,
        this
      ], this), this._hoveredItem = i, i && !a && T(e.onHover, [
        t,
        i,
        this
      ], this);
    } else i && T(e.onClick, [
      t,
      i,
      this
    ], this);
  }
}
function Ja(o, t, e, i, s) {
  const a = Za(i, o, t, e), n = Qa(s, i, t.lineHeight);
  return {
    itemWidth: a,
    itemHeight: n
  };
}
function Za(o, t, e, i) {
  let s = o.text;
  return s && typeof s != "string" && (s = s.reduce((a, n) => a.length > n.length ? a : n)), t + e.size / 2 + i.measureText(s).width;
}
function Qa(o, t, e) {
  let i = o;
  return typeof t.text != "string" && (i = Ki(t, e)), i;
}
function Ki(o, t) {
  const e = o.text ? o.text.length : 0;
  return t * e;
}
function tn(o, t) {
  return !!((o === "mousemove" || o === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (o === "click" || o === "mouseup"));
}
var wn = {
  id: "legend",
  _element: pi,
  start(o, t, e) {
    const i = o.legend = new pi({
      ctx: o.ctx,
      options: e,
      chart: o
    });
    H.configure(o, i, e), H.addBox(o, i);
  },
  stop(o) {
    H.removeBox(o, o.legend), delete o.legend;
  },
  beforeUpdate(o, t, e) {
    const i = o.legend;
    H.configure(o, i, e), i.options = e;
  },
  afterUpdate(o) {
    const t = o.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(o, t) {
    t.replay || o.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(o, t, e) {
      const i = t.datasetIndex, s = e.chart;
      s.isDatasetVisible(i) ? (s.hide(i), t.hidden = !0) : (s.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (o) => o.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(o) {
        const t = o.data.datasets, { labels: { usePointStyle: e, pointStyle: i, textAlign: s, color: a, useBorderRadius: n, borderRadius: r } } = o.legend.options;
        return o._getSortedDatasetMetas().map((h) => {
          const l = h.controller.getStyle(e ? 0 : void 0), c = W(l.borderWidth);
          return {
            text: t[h.index].label,
            fillStyle: l.backgroundColor,
            fontColor: a,
            hidden: !h.visible,
            lineCap: l.borderCapStyle,
            lineDash: l.borderDash,
            lineDashOffset: l.borderDashOffset,
            lineJoin: l.borderJoinStyle,
            lineWidth: (c.width + c.height) / 4,
            strokeStyle: l.borderColor,
            pointStyle: i || l.pointStyle,
            rotation: l.rotation,
            textAlign: s || l.textAlign,
            borderRadius: n && (r || l.borderRadius),
            datasetIndex: h.index
          };
        }, this);
      }
    },
    title: {
      color: (o) => o.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (o) => !o.startsWith("on"),
    labels: {
      _scriptable: (o) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(o)
    }
  }
};
class Gi extends it {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const s = V(i.text) ? i.text.length : 1;
    this._padding = W(i.padding);
    const a = s * F(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: i, bottom: s, right: a, options: n } = this, r = n.align;
    let h = 0, l, c, d;
    return this.isHorizontal() ? (c = $(r, i, a), d = e + t, l = a - i) : (n.position === "left" ? (c = i + t, d = $(r, s, e), h = Wt * -0.5) : (c = a - t, d = $(r, e, s), h = Wt * 0.5), l = s - e), {
      titleX: c,
      titleY: d,
      maxWidth: l,
      rotation: h
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const i = F(e.font), s = i.lineHeight / 2 + this._padding.top, { titleX: a, titleY: n, maxWidth: r, rotation: h } = this._drawArgs(s);
    Dt(t, e.text, 0, 0, i, {
      color: e.color,
      maxWidth: r,
      rotation: h,
      textAlign: be(e.align),
      textBaseline: "middle",
      translation: [
        a,
        n
      ]
    });
  }
}
function en(o, t) {
  const e = new Gi({
    ctx: o.ctx,
    options: t,
    chart: o
  });
  H.configure(o, e, t), H.addBox(o, e), o.titleBlock = e;
}
var Mn = {
  id: "title",
  _element: Gi,
  start(o, t, e) {
    en(o, e);
  },
  stop(o) {
    const t = o.titleBlock;
    H.removeBox(o, t), delete o.titleBlock;
  },
  beforeUpdate(o, t, e) {
    const i = o.titleBlock;
    H.configure(o, i, e), i.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const kt = {
  average(o) {
    if (!o.length)
      return !1;
    let t, e, i = /* @__PURE__ */ new Set(), s = 0, a = 0;
    for (t = 0, e = o.length; t < e; ++t) {
      const n = o[t].element;
      if (n && n.hasValue()) {
        const r = n.tooltipPosition();
        i.add(r.x), s += r.y, ++a;
      }
    }
    return a === 0 || i.size === 0 ? !1 : {
      x: [
        ...i
      ].reduce((n, r) => n + r) / i.size,
      y: s / a
    };
  },
  nearest(o, t) {
    if (!o.length)
      return !1;
    let e = t.x, i = t.y, s = Number.POSITIVE_INFINITY, a, n, r;
    for (a = 0, n = o.length; a < n; ++a) {
      const h = o[a].element;
      if (h && h.hasValue()) {
        const l = h.getCenterPoint(), c = cs(t, l);
        c < s && (s = c, r = h);
      }
    }
    if (r) {
      const h = r.tooltipPosition();
      e = h.x, i = h.y;
    }
    return {
      x: e,
      y: i
    };
  }
};
function X(o, t) {
  return t && (V(t) ? Array.prototype.push.apply(o, t) : o.push(t)), o;
}
function J(o) {
  return (typeof o == "string" || o instanceof String) && o.indexOf(`
`) > -1 ? o.split(`
`) : o;
}
function sn(o, t) {
  const { element: e, datasetIndex: i, index: s } = t, a = o.getDatasetMeta(i).controller, { label: n, value: r } = a.getLabelAndValue(s);
  return {
    chart: o,
    label: n,
    parsed: a.getParsed(s),
    raw: o.data.datasets[i].data[s],
    formattedValue: r,
    dataset: a.getDataset(),
    dataIndex: s,
    datasetIndex: i,
    element: e
  };
}
function xi(o, t) {
  const e = o.chart.ctx, { body: i, footer: s, title: a } = o, { boxWidth: n, boxHeight: r } = t, h = F(t.bodyFont), l = F(t.titleFont), c = F(t.footerFont), d = a.length, u = s.length, g = i.length, f = W(t.padding);
  let p = f.height, m = 0, x = i.reduce((_, b) => _ + b.before.length + b.lines.length + b.after.length, 0);
  if (x += o.beforeBody.length + o.afterBody.length, d && (p += d * l.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), x) {
    const _ = t.displayColors ? Math.max(r, h.lineHeight) : h.lineHeight;
    p += g * _ + (x - g) * h.lineHeight + (x - 1) * t.bodySpacing;
  }
  u && (p += t.footerMarginTop + u * c.lineHeight + (u - 1) * t.footerSpacing);
  let v = 0;
  const y = function(_) {
    m = Math.max(m, e.measureText(_).width + v);
  };
  return e.save(), e.font = l.string, C(o.title, y), e.font = h.string, C(o.beforeBody.concat(o.afterBody), y), v = t.displayColors ? n + 2 + t.boxPadding : 0, C(i, (_) => {
    C(_.before, y), C(_.lines, y), C(_.after, y);
  }), v = 0, e.font = c.string, C(o.footer, y), e.restore(), m += f.width, {
    width: m,
    height: p
  };
}
function on(o, t) {
  const { y: e, height: i } = t;
  return e < i / 2 ? "top" : e > o.height - i / 2 ? "bottom" : "center";
}
function an(o, t, e, i) {
  const { x: s, width: a } = i, n = e.caretSize + e.caretPadding;
  if (o === "left" && s + a + n > t.width || o === "right" && s - a - n < 0)
    return !0;
}
function nn(o, t, e, i) {
  const { x: s, width: a } = e, { width: n, chartArea: { left: r, right: h } } = o;
  let l = "center";
  return i === "center" ? l = s <= (r + h) / 2 ? "left" : "right" : s <= a / 2 ? l = "left" : s >= n - a / 2 && (l = "right"), an(l, o, t, e) && (l = "center"), l;
}
function mi(o, t, e) {
  const i = e.yAlign || t.yAlign || on(o, e);
  return {
    xAlign: e.xAlign || t.xAlign || nn(o, t, e, i),
    yAlign: i
  };
}
function rn(o, t) {
  let { x: e, width: i } = o;
  return t === "right" ? e -= i : t === "center" && (e -= i / 2), e;
}
function hn(o, t, e) {
  let { y: i, height: s } = o;
  return t === "top" ? i += e : t === "bottom" ? i -= s + e : i -= s / 2, i;
}
function _i(o, t, e, i) {
  const { caretSize: s, caretPadding: a, cornerRadius: n } = o, { xAlign: r, yAlign: h } = e, l = s + a, { topLeft: c, topRight: d, bottomLeft: u, bottomRight: g } = ct(n);
  let f = rn(t, r);
  const p = hn(t, h, l);
  return h === "center" ? r === "left" ? f += l : r === "right" && (f -= l) : r === "left" ? f -= Math.max(c, u) + s : r === "right" && (f += Math.max(d, g) + s), {
    x: Q(f, 0, i.width - t.width),
    y: Q(p, 0, i.height - t.height)
  };
}
function $t(o, t, e) {
  const i = W(e.padding);
  return t === "center" ? o.x + o.width / 2 : t === "right" ? o.x + o.width - i.right : o.x + i.left;
}
function bi(o) {
  return X([], J(o));
}
function ln(o, t, e) {
  return ft(o, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function yi(o, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? o.override(e) : o;
}
const Ji = {
  beforeTitle: K,
  title(o) {
    if (o.length > 0) {
      const t = o[0], e = t.chart.data.labels, i = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: K,
  beforeBody: K,
  beforeLabel: K,
  label(o) {
    if (this && this.options && this.options.mode === "dataset")
      return o.label + ": " + o.formattedValue || o.formattedValue;
    let t = o.dataset.label || "";
    t && (t += ": ");
    const e = o.formattedValue;
    return L(e) || (t += e), t;
  },
  labelColor(o) {
    const t = o.chart.getDatasetMeta(o.datasetIndex).controller.getStyle(o.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(o) {
    const t = o.chart.getDatasetMeta(o.datasetIndex).controller.getStyle(o.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: K,
  afterBody: K,
  beforeFooter: K,
  footer: K,
  afterFooter: K
};
function B(o, t, e, i) {
  const s = o[t].call(e, i);
  return typeof s > "u" ? Ji[t].call(e, i) : s;
}
class vi extends it {
  static positioners = kt;
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, i = this.options.setContext(this.getContext()), s = i.enabled && e.options.animation && i.animations, a = new Oi(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = ln(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: i } = e, s = B(i, "beforeTitle", this, t), a = B(i, "title", this, t), n = B(i, "afterTitle", this, t);
    let r = [];
    return r = X(r, J(s)), r = X(r, J(a)), r = X(r, J(n)), r;
  }
  getBeforeBody(t, e) {
    return bi(B(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: i } = e, s = [];
    return C(t, (a) => {
      const n = {
        before: [],
        lines: [],
        after: []
      }, r = yi(i, a);
      X(n.before, J(B(r, "beforeLabel", this, a))), X(n.lines, B(r, "label", this, a)), X(n.after, J(B(r, "afterLabel", this, a))), s.push(n);
    }), s;
  }
  getAfterBody(t, e) {
    return bi(B(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: i } = e, s = B(i, "beforeFooter", this, t), a = B(i, "footer", this, t), n = B(i, "afterFooter", this, t);
    let r = [];
    return r = X(r, J(s)), r = X(r, J(a)), r = X(r, J(n)), r;
  }
  _createItems(t) {
    const e = this._active, i = this.chart.data, s = [], a = [], n = [];
    let r = [], h, l;
    for (h = 0, l = e.length; h < l; ++h)
      r.push(sn(this.chart, e[h]));
    return t.filter && (r = r.filter((c, d, u) => t.filter(c, d, u, i))), t.itemSort && (r = r.sort((c, d) => t.itemSort(c, d, i))), C(r, (c) => {
      const d = yi(t.callbacks, c);
      s.push(B(d, "labelColor", this, c)), a.push(B(d, "labelPointStyle", this, c)), n.push(B(d, "labelTextColor", this, c));
    }), this.labelColors = s, this.labelPointStyles = a, this.labelTextColors = n, this.dataPoints = r, r;
  }
  update(t, e) {
    const i = this.options.setContext(this.getContext()), s = this._active;
    let a, n = [];
    if (!s.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const r = kt[i.position].call(this, s, this._eventPosition);
      n = this._createItems(i), this.title = this.getTitle(n, i), this.beforeBody = this.getBeforeBody(n, i), this.body = this.getBody(n, i), this.afterBody = this.getAfterBody(n, i), this.footer = this.getFooter(n, i);
      const h = this._size = xi(this, i), l = Object.assign({}, r, h), c = mi(this.chart, i, l), d = _i(i, l, c, this.chart);
      this.xAlign = c.xAlign, this.yAlign = c.yAlign, a = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: h.width,
        height: h.height,
        caretX: r.x,
        caretY: r.y
      };
    }
    this._tooltipItems = n, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, i, s) {
    const a = this.getCaretPosition(t, i, s);
    e.lineTo(a.x1, a.y1), e.lineTo(a.x2, a.y2), e.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, e, i) {
    const { xAlign: s, yAlign: a } = this, { caretSize: n, cornerRadius: r } = i, { topLeft: h, topRight: l, bottomLeft: c, bottomRight: d } = ct(r), { x: u, y: g } = t, { width: f, height: p } = e;
    let m, x, v, y, _, b;
    return a === "center" ? (_ = g + p / 2, s === "left" ? (m = u, x = m - n, y = _ + n, b = _ - n) : (m = u + f, x = m + n, y = _ - n, b = _ + n), v = m) : (s === "left" ? x = u + Math.max(h, c) + n : s === "right" ? x = u + f - Math.max(l, d) - n : x = this.caretX, a === "top" ? (y = g, _ = y - n, m = x - n, v = x + n) : (y = g + p, _ = y + n, m = x + n, v = x - n), b = y), {
      x1: m,
      x2: x,
      x3: v,
      y1: y,
      y2: _,
      y3: b
    };
  }
  drawTitle(t, e, i) {
    const s = this.title, a = s.length;
    let n, r, h;
    if (a) {
      const l = dt(i.rtl, this.x, this.width);
      for (t.x = $t(this, i.titleAlign, i), e.textAlign = l.textAlign(i.titleAlign), e.textBaseline = "middle", n = F(i.titleFont), r = i.titleSpacing, e.fillStyle = i.titleColor, e.font = n.string, h = 0; h < a; ++h)
        e.fillText(s[h], l.x(t.x), t.y + n.lineHeight / 2), t.y += n.lineHeight + r, h + 1 === a && (t.y += i.titleMarginBottom - r);
    }
  }
  _drawColorBox(t, e, i, s, a) {
    const n = this.labelColors[i], r = this.labelPointStyles[i], { boxHeight: h, boxWidth: l } = a, c = F(a.bodyFont), d = $t(this, "left", a), u = s.x(d), g = h < c.lineHeight ? (c.lineHeight - h) / 2 : 0, f = e.y + g;
    if (a.usePointStyle) {
      const p = {
        radius: Math.min(l, h) / 2,
        pointStyle: r.pointStyle,
        rotation: r.rotation,
        borderWidth: 1
      }, m = s.leftForLtr(u, l) + l / 2, x = f + h / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, ue(t, p, m, x), t.strokeStyle = n.borderColor, t.fillStyle = n.backgroundColor, ue(t, p, m, x);
    } else {
      t.lineWidth = E(n.borderWidth) ? Math.max(...Object.values(n.borderWidth)) : n.borderWidth || 1, t.strokeStyle = n.borderColor, t.setLineDash(n.borderDash || []), t.lineDashOffset = n.borderDashOffset || 0;
      const p = s.leftForLtr(u, l), m = s.leftForLtr(s.xPlus(u, 1), l - 2), x = ct(n.borderRadius);
      Object.values(x).some((v) => v !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, Ht(t, {
        x: p,
        y: f,
        w: l,
        h,
        radius: x
      }), t.fill(), t.stroke(), t.fillStyle = n.backgroundColor, t.beginPath(), Ht(t, {
        x: m,
        y: f + 1,
        w: l - 2,
        h: h - 2,
        radius: x
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(p, f, l, h), t.strokeRect(p, f, l, h), t.fillStyle = n.backgroundColor, t.fillRect(m, f + 1, l - 2, h - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, e, i) {
    const { body: s } = this, { bodySpacing: a, bodyAlign: n, displayColors: r, boxHeight: h, boxWidth: l, boxPadding: c } = i, d = F(i.bodyFont);
    let u = d.lineHeight, g = 0;
    const f = dt(i.rtl, this.x, this.width), p = function(w) {
      e.fillText(w, f.x(t.x + g), t.y + u / 2), t.y += u + a;
    }, m = f.textAlign(n);
    let x, v, y, _, b, M, k;
    for (e.textAlign = n, e.textBaseline = "middle", e.font = d.string, t.x = $t(this, m, i), e.fillStyle = i.bodyColor, C(this.beforeBody, p), g = r && m !== "right" ? n === "center" ? l / 2 + c : l + 2 + c : 0, _ = 0, M = s.length; _ < M; ++_) {
      for (x = s[_], v = this.labelTextColors[_], e.fillStyle = v, C(x.before, p), y = x.lines, r && y.length && (this._drawColorBox(e, t, _, f, i), u = Math.max(d.lineHeight, h)), b = 0, k = y.length; b < k; ++b)
        p(y[b]), u = d.lineHeight;
      C(x.after, p);
    }
    g = 0, u = d.lineHeight, C(this.afterBody, p), t.y -= a;
  }
  drawFooter(t, e, i) {
    const s = this.footer, a = s.length;
    let n, r;
    if (a) {
      const h = dt(i.rtl, this.x, this.width);
      for (t.x = $t(this, i.footerAlign, i), t.y += i.footerMarginTop, e.textAlign = h.textAlign(i.footerAlign), e.textBaseline = "middle", n = F(i.footerFont), e.fillStyle = i.footerColor, e.font = n.string, r = 0; r < a; ++r)
        e.fillText(s[r], h.x(t.x), t.y + n.lineHeight / 2), t.y += n.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, e, i, s) {
    const { xAlign: a, yAlign: n } = this, { x: r, y: h } = t, { width: l, height: c } = i, { topLeft: d, topRight: u, bottomLeft: g, bottomRight: f } = ct(s.cornerRadius);
    e.fillStyle = s.backgroundColor, e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.beginPath(), e.moveTo(r + d, h), n === "top" && this.drawCaret(t, e, i, s), e.lineTo(r + l - u, h), e.quadraticCurveTo(r + l, h, r + l, h + u), n === "center" && a === "right" && this.drawCaret(t, e, i, s), e.lineTo(r + l, h + c - f), e.quadraticCurveTo(r + l, h + c, r + l - f, h + c), n === "bottom" && this.drawCaret(t, e, i, s), e.lineTo(r + g, h + c), e.quadraticCurveTo(r, h + c, r, h + c - g), n === "center" && a === "left" && this.drawCaret(t, e, i, s), e.lineTo(r, h + d), e.quadraticCurveTo(r, h, r + d, h), e.closePath(), e.fill(), s.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, i = this.$animations, s = i && i.x, a = i && i.y;
    if (s || a) {
      const n = kt[t.position].call(this, this._active, this._eventPosition);
      if (!n)
        return;
      const r = this._size = xi(this, t), h = Object.assign({}, n, this._size), l = mi(e, t, h), c = _i(t, h, l, e);
      (s._to !== c.x || a._to !== c.y) && (this.xAlign = l.xAlign, this.yAlign = l.yAlign, this.width = r.width, this.height = r.height, this.caretX = n.x, this.caretY = n.y, this._resolveAnimations().update(this, c));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(e);
    const s = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const n = W(e.padding), r = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && r && (t.save(), t.globalAlpha = i, this.drawBackground(a, t, s, e), Pi(t, e.textDirection), a.y += n.top, this.drawTitle(a, t, e), this.drawBody(a, t, e), this.drawFooter(a, t, e), Ai(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const i = this._active, s = t.map(({ datasetIndex: r, index: h }) => {
      const l = this.chart.getDatasetMeta(r);
      if (!l)
        throw new Error("Cannot find a dataset at index " + r);
      return {
        datasetIndex: r,
        element: l.data[h],
        index: h
      };
    }), a = !Vt(i, s), n = this._positionChanged(s, e);
    (a || n) && (this._active = s, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, i = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, a = this._active || [], n = this._getActiveElements(t, a, e, i), r = this._positionChanged(n, t), h = e || !Vt(n, a) || r;
    return h && (this._active = n, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), h;
  }
  _getActiveElements(t, e, i, s) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return e.filter((r) => this.chart.data.datasets[r.datasetIndex] && this.chart.getDatasetMeta(r.datasetIndex).controller.getParsed(r.index) !== void 0);
    const n = this.chart.getElementsAtEventForMode(t, a.mode, a, i);
    return a.reverse && n.reverse(), n;
  }
  _positionChanged(t, e) {
    const { caretX: i, caretY: s, options: a } = this, n = kt[a.position].call(this, t, e);
    return n !== !1 && (i !== n.x || s !== n.y);
  }
}
var kn = {
  id: "tooltip",
  _element: vi,
  positioners: kt,
  afterInit(o, t, e) {
    e && (o.tooltip = new vi({
      chart: o,
      options: e
    }));
  },
  beforeUpdate(o, t, e) {
    o.tooltip && o.tooltip.initialize(e);
  },
  reset(o, t, e) {
    o.tooltip && o.tooltip.initialize(e);
  },
  afterDraw(o) {
    const t = o.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (o.notifyPlugins("beforeTooltipDraw", {
        ...e,
        cancelable: !0
      }) === !1)
        return;
      t.draw(o.ctx), o.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(o, t) {
    if (o.tooltip) {
      const e = t.replay;
      o.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (o, t) => t.bodyFont.size,
    boxWidth: (o, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Ji
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (o) => o !== "filter" && o !== "itemSort" && o !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const cn = (o, t, e, i) => (typeof t == "string" ? (e = o.push(t) - 1, i.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function dn(o, t, e, i) {
  const s = o.indexOf(t);
  if (s === -1)
    return cn(o, t, e, i);
  const a = o.lastIndexOf(t);
  return s !== a ? e : s;
}
const un = (o, t) => o === null ? null : Q(Math.round(o), 0, t);
function wi(o) {
  const t = this.getLabels();
  return o >= 0 && o < t.length ? t[o] : o;
}
class Sn extends At {
  static id = "category";
  static defaults = {
    ticks: {
      callback: wi
    }
  };
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const i = this.getLabels();
      for (const { index: s, label: a } of e)
        i[s] === a && i.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (L(t))
      return null;
    const i = this.getLabels();
    return e = isFinite(e) && i[e] === t ? e : dn(i, t, P(e, t), this._addedLabels), un(e, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: i, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), e || (s = this.getLabels().length - 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const t = this.min, e = this.max, i = this.options.offset, s = [];
    let a = this.getLabels();
    a = t === 0 && e === a.length - 1 ? a : a.slice(t, e + 1), this._valueRange = Math.max(a.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let n = t; n <= e; n++)
      s.push({
        value: n
      });
    return s;
  }
  getLabelForValue(t) {
    return wi.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
function gn(o, t) {
  const e = [], { bounds: i, step: s, min: a, max: n, precision: r, count: h, maxTicks: l, maxDigits: c, includeBounds: d } = o, u = s || 1, g = l - 1, { min: f, max: p } = t, m = !L(a), x = !L(n), v = !L(h), y = (p - f) / (c + 1);
  let _ = Ie((p - f) / g / u) * u, b, M, k, w;
  if (_ < 1e-14 && !m && !x)
    return [
      {
        value: f
      },
      {
        value: p
      }
    ];
  w = Math.ceil(p / _) - Math.floor(f / _), w > g && (_ = Ie(w * _ / g / u) * u), L(r) || (b = Math.pow(10, r), _ = Math.ceil(_ * b) / b), i === "ticks" ? (M = Math.floor(f / _) * _, k = Math.ceil(p / _) * _) : (M = f, k = p), m && x && s && Ss((n - a) / s, _ / 1e3) ? (w = Math.round(Math.min((n - a) / _, l)), _ = (n - a) / w, M = a, k = n) : v ? (M = m ? a : M, k = x ? n : k, w = h - 1, _ = (k - M) / w) : (w = (k - M) / _, Zt(w, Math.round(w), _ / 1e3) ? w = Math.round(w) : w = Math.ceil(w));
  const O = Math.max(Oe(_), Oe(M));
  b = Math.pow(10, L(r) ? O : r), M = Math.round(M * b) / b, k = Math.round(k * b) / b;
  let S = 0;
  for (m && (d && M !== a ? (e.push({
    value: a
  }), M < a && S++, Zt(Math.round((M + S * _) * b) / b, a, Mi(a, y, o)) && S++) : M < a && S++); S < w; ++S) {
    const D = Math.round((M + S * _) * b) / b;
    if (x && D > n)
      break;
    e.push({
      value: D
    });
  }
  return x && d && k !== n ? e.length && Zt(e[e.length - 1].value, n, Mi(n, y, o)) ? e[e.length - 1].value = n : e.push({
    value: n
  }) : (!x || k === n) && e.push({
    value: k
  }), e;
}
function Mi(o, t, { horizontal: e, minRotation: i }) {
  const s = Z(i), a = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, n = 0.75 * t * ("" + o).length;
  return Math.min(t / a, n);
}
class fn extends At {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return L(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: i } = this.getUserBounds();
    let { min: s, max: a } = this;
    const n = (h) => s = e ? s : h, r = (h) => a = i ? a : h;
    if (t) {
      const h = et(s), l = et(a);
      h < 0 && l < 0 ? r(0) : h > 0 && l > 0 && n(0);
    }
    if (s === a) {
      let h = a === 0 ? 1 : Math.abs(a * 0.05);
      r(a + h), t || n(s - h);
    }
    this.min = s, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: i } = t, s;
    return i ? (s = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), e = e || 11), e && (s = Math.min(e, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const s = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, a = this._range || this, n = gn(s, a);
    return t.bounds === "ticks" && xs(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (i - e) / Math.max(t.length - 1, 1) / 2;
      e -= s, i += s;
    }
    this._startValue = e, this._endValue = i, this._valueRange = i - e;
  }
  getLabelForValue(t) {
    return ki(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Dn extends fn {
  static id = "linear";
  static defaults = {
    ticks: {
      callback: rs.formatters.numeric
    }
  };
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = N(t) ? t : 0, this.max = N(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, i = Z(this.options.ticks.minRotation), s = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, a.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
export {
  Fs as Animation,
  Oi as Animations,
  xn as BarController,
  yn as BarElement,
  $i as BasePlatform,
  yo as BasicPlatform,
  Sn as CategoryScale,
  xa as Chart,
  qt as DatasetController,
  Oo as DomPlatform,
  mn as DoughnutController,
  it as Element,
  vn as Filler,
  uo as Interaction,
  wn as Legend,
  _n as LineController,
  ye as LineElement,
  Dn as LinearScale,
  bn as PointElement,
  At as Scale,
  rs as Ticks,
  Mn as Title,
  kn as Tooltip,
  Lo as _detectPlatform,
  G as animator,
  z as defaults,
  H as layouts,
  q as registry
};
//# sourceMappingURL=index.es68.js.map
